var map = {
	"./fontawesome/abacus.svg": "2jNB",
	"./fontawesome/acorn.svg": "p9+/",
	"./fontawesome/ad.svg": "KmNH",
	"./fontawesome/address-book.svg": "1NnO",
	"./fontawesome/address-card.svg": "Fq7n",
	"./fontawesome/adjust.svg": "jpnB",
	"./fontawesome/air-conditioner.svg": "61wA",
	"./fontawesome/air-freshener.svg": "lE4G",
	"./fontawesome/alarm-clock.svg": "sckc",
	"./fontawesome/alarm-exclamation.svg": "Lhjl",
	"./fontawesome/alarm-plus.svg": "DkiN",
	"./fontawesome/alarm-snooze.svg": "PZ8x",
	"./fontawesome/album-collection.svg": "otmp",
	"./fontawesome/album.svg": "rOBR",
	"./fontawesome/alicorn.svg": "Z6zH",
	"./fontawesome/alien-monster.svg": "kZHN",
	"./fontawesome/alien.svg": "Mjzm",
	"./fontawesome/align-center.svg": "n/FN",
	"./fontawesome/align-justify.svg": "GS4l",
	"./fontawesome/align-left.svg": "LaGm",
	"./fontawesome/align-right.svg": "UkP0",
	"./fontawesome/align-slash.svg": "gmZn",
	"./fontawesome/allergies.svg": "ty0o",
	"./fontawesome/ambulance.svg": "VDPa",
	"./fontawesome/american-sign-language-interpreting.svg": "UZ5q",
	"./fontawesome/amp-guitar.svg": "GDat",
	"./fontawesome/analytics.svg": "nJKL",
	"./fontawesome/anchor.svg": "K7AK",
	"./fontawesome/angel.svg": "5SBG",
	"./fontawesome/angle-double-down.svg": "NKWc",
	"./fontawesome/angle-double-left.svg": "eQ7b",
	"./fontawesome/angle-double-right.svg": "BOuL",
	"./fontawesome/angle-double-up.svg": "iTbG",
	"./fontawesome/angle-down.svg": "AcWx",
	"./fontawesome/angle-left.svg": "OZlY",
	"./fontawesome/angle-right.svg": "mmhj",
	"./fontawesome/angle-up.svg": "XEEk",
	"./fontawesome/angry.svg": "f/hf",
	"./fontawesome/ankh.svg": "c/7K",
	"./fontawesome/apple-alt.svg": "2QCU",
	"./fontawesome/apple-crate.svg": "vGTX",
	"./fontawesome/archive.svg": "poDY",
	"./fontawesome/archway.svg": "b9ia",
	"./fontawesome/arrow-alt-circle-down.svg": "h6Z/",
	"./fontawesome/arrow-alt-circle-left.svg": "lzK3",
	"./fontawesome/arrow-alt-circle-right.svg": "NKVb",
	"./fontawesome/arrow-alt-circle-up.svg": "CdoX",
	"./fontawesome/arrow-alt-down.svg": "924+",
	"./fontawesome/arrow-alt-from-bottom.svg": "88xv",
	"./fontawesome/arrow-alt-from-left.svg": "hUVo",
	"./fontawesome/arrow-alt-from-right.svg": "dLY8",
	"./fontawesome/arrow-alt-from-top.svg": "SfIh",
	"./fontawesome/arrow-alt-left.svg": "ghWY",
	"./fontawesome/arrow-alt-right.svg": "UUo1",
	"./fontawesome/arrow-alt-square-down.svg": "fDUN",
	"./fontawesome/arrow-alt-square-left.svg": "abjK",
	"./fontawesome/arrow-alt-square-right.svg": "fIL1",
	"./fontawesome/arrow-alt-square-up.svg": "8Lwo",
	"./fontawesome/arrow-alt-to-bottom.svg": "FvvE",
	"./fontawesome/arrow-alt-to-left.svg": "Ck9N",
	"./fontawesome/arrow-alt-to-right.svg": "xZgG",
	"./fontawesome/arrow-alt-to-top.svg": "3Y68",
	"./fontawesome/arrow-alt-up.svg": "39pm",
	"./fontawesome/arrow-circle-down.svg": "aIRd",
	"./fontawesome/arrow-circle-left.svg": "Zzwm",
	"./fontawesome/arrow-circle-right.svg": "JAad",
	"./fontawesome/arrow-circle-up.svg": "PzFt",
	"./fontawesome/arrow-down.svg": "CpG2",
	"./fontawesome/arrow-from-bottom.svg": "CjNh",
	"./fontawesome/arrow-from-left.svg": "1iSL",
	"./fontawesome/arrow-from-right.svg": "SVtp",
	"./fontawesome/arrow-from-top.svg": "Y9LU",
	"./fontawesome/arrow-left.svg": "FbpZ",
	"./fontawesome/arrow-right.svg": "cuku",
	"./fontawesome/arrow-square-down.svg": "nJN5",
	"./fontawesome/arrow-square-left.svg": "0wuc",
	"./fontawesome/arrow-square-right.svg": "axl7",
	"./fontawesome/arrow-square-up.svg": "5hsH",
	"./fontawesome/arrow-to-bottom.svg": "obfz",
	"./fontawesome/arrow-to-left.svg": "F4tr",
	"./fontawesome/arrow-to-right.svg": "yykY",
	"./fontawesome/arrow-to-top.svg": "ss1N",
	"./fontawesome/arrow-up.svg": "swCt",
	"./fontawesome/arrows-alt-h.svg": "drae",
	"./fontawesome/arrows-alt-v.svg": "Ifwe",
	"./fontawesome/arrows-alt.svg": "vTFE",
	"./fontawesome/arrows-h.svg": "zrQS",
	"./fontawesome/arrows-v.svg": "lV1D",
	"./fontawesome/arrows.svg": "0Jb4",
	"./fontawesome/assistive-listening-systems.svg": "c+Lo",
	"./fontawesome/asterisk.svg": "Co04",
	"./fontawesome/at.svg": "bCyK",
	"./fontawesome/atlas.svg": "9i8m",
	"./fontawesome/atom-alt.svg": "ig1S",
	"./fontawesome/atom.svg": "al3f",
	"./fontawesome/audio-description.svg": "IZ4x",
	"./fontawesome/award.svg": "bzlG",
	"./fontawesome/axe-battle.svg": "E0y/",
	"./fontawesome/axe.svg": "GGYA",
	"./fontawesome/baby-carriage.svg": "9/Zb",
	"./fontawesome/baby.svg": "ciId",
	"./fontawesome/backpack.svg": "WyGO",
	"./fontawesome/backspace.svg": "J4Li",
	"./fontawesome/backward.svg": "Pfg4",
	"./fontawesome/bacon.svg": "honj",
	"./fontawesome/bacteria.svg": "2c07",
	"./fontawesome/bacterium.svg": "KWEq",
	"./fontawesome/badge-check.svg": "NwZQ",
	"./fontawesome/badge-dollar.svg": "Pjof",
	"./fontawesome/badge-percent.svg": "2ce/",
	"./fontawesome/badge-sheriff.svg": "vPeT",
	"./fontawesome/badge.svg": "y79L",
	"./fontawesome/badger-honey.svg": "wzxy",
	"./fontawesome/bags-shopping.svg": "1o76",
	"./fontawesome/bahai.svg": "617N",
	"./fontawesome/balance-scale-left.svg": "7O8L",
	"./fontawesome/balance-scale-right.svg": "UsDk",
	"./fontawesome/balance-scale.svg": "rgbY",
	"./fontawesome/ball-pile.svg": "gSoP",
	"./fontawesome/ballot-check.svg": "XA6U",
	"./fontawesome/ballot.svg": "pi2y",
	"./fontawesome/ban.svg": "NHaw",
	"./fontawesome/band-aid.svg": "8nuj",
	"./fontawesome/banjo.svg": "puI+",
	"./fontawesome/barcode-alt.svg": "w0jQ",
	"./fontawesome/barcode-read.svg": "Blr8",
	"./fontawesome/barcode-scan.svg": "Ys/S",
	"./fontawesome/barcode.svg": "Bq6p",
	"./fontawesome/bars.svg": "Fojo",
	"./fontawesome/baseball-ball.svg": "oncj",
	"./fontawesome/baseball.svg": "1PWv",
	"./fontawesome/basketball-ball.svg": "BoFP",
	"./fontawesome/basketball-hoop.svg": "50sp",
	"./fontawesome/bat.svg": "Ecp9",
	"./fontawesome/bath.svg": "949G",
	"./fontawesome/battery-bolt.svg": "3Ump",
	"./fontawesome/battery-empty.svg": "Z98W",
	"./fontawesome/battery-full.svg": "JdNQ",
	"./fontawesome/battery-half.svg": "TmHR",
	"./fontawesome/battery-quarter.svg": "/+Nh",
	"./fontawesome/battery-slash.svg": "f6ZZ",
	"./fontawesome/battery-three-quarters.svg": "bR1t",
	"./fontawesome/bed-alt.svg": "X/sM",
	"./fontawesome/bed-bunk.svg": "K2op",
	"./fontawesome/bed-empty.svg": "vjs7",
	"./fontawesome/bed.svg": "/Wlt",
	"./fontawesome/beer.svg": "xvj/",
	"./fontawesome/bell-exclamation.svg": "SVBJ",
	"./fontawesome/bell-on.svg": "ZcmF",
	"./fontawesome/bell-plus.svg": "tCvh",
	"./fontawesome/bell-school-slash.svg": "PopC",
	"./fontawesome/bell-school.svg": "38/Z",
	"./fontawesome/bell-slash.svg": "lb54",
	"./fontawesome/bell.svg": "H301",
	"./fontawesome/bells.svg": "vf45",
	"./fontawesome/betamax.svg": "4kPG",
	"./fontawesome/bezier-curve.svg": "hfjG",
	"./fontawesome/bible.svg": "gQpo",
	"./fontawesome/bicycle.svg": "JWWc",
	"./fontawesome/biking-mountain.svg": "D/jz",
	"./fontawesome/biking.svg": "3rW/",
	"./fontawesome/binoculars.svg": "ZpHw",
	"./fontawesome/biohazard.svg": "nI1H",
	"./fontawesome/birthday-cake.svg": "uGi2",
	"./fontawesome/blanket.svg": "xct8",
	"./fontawesome/blender-phone.svg": "HXPl",
	"./fontawesome/blender.svg": "fC1p",
	"./fontawesome/blind.svg": "fKIr",
	"./fontawesome/blinds-open.svg": "3cL5",
	"./fontawesome/blinds-raised.svg": "TEJj",
	"./fontawesome/blinds.svg": "hnoS",
	"./fontawesome/blog.svg": "w7Ph",
	"./fontawesome/bold.svg": "qzLm",
	"./fontawesome/bolt.svg": "dXoV",
	"./fontawesome/bomb.svg": "ma5a",
	"./fontawesome/bone-break.svg": "YrWz",
	"./fontawesome/bone.svg": "h+Fp",
	"./fontawesome/bong.svg": "QJ2o",
	"./fontawesome/book-alt.svg": "gYBW",
	"./fontawesome/book-dead.svg": "ca72",
	"./fontawesome/book-heart.svg": "e3tK",
	"./fontawesome/book-medical.svg": "ywSU",
	"./fontawesome/book-open.svg": "8Pmo",
	"./fontawesome/book-reader.svg": "CjXi",
	"./fontawesome/book-spells.svg": "iioF",
	"./fontawesome/book-user.svg": "lpZh",
	"./fontawesome/book.svg": "QCJs",
	"./fontawesome/bookmark.svg": "GZX4",
	"./fontawesome/books-medical.svg": "AsYM",
	"./fontawesome/books.svg": "mDIA",
	"./fontawesome/boombox.svg": "GcGz",
	"./fontawesome/boot.svg": "M7b2",
	"./fontawesome/booth-curtain.svg": "J/LM",
	"./fontawesome/border-all.svg": "eabz",
	"./fontawesome/border-bottom.svg": "i4BT",
	"./fontawesome/border-center-h.svg": "lGzG",
	"./fontawesome/border-center-v.svg": "uF+H",
	"./fontawesome/border-inner.svg": "dH/P",
	"./fontawesome/border-left.svg": "Flei",
	"./fontawesome/border-none.svg": "QR18",
	"./fontawesome/border-outer.svg": "/7ul",
	"./fontawesome/border-right.svg": "JcGl",
	"./fontawesome/border-style-alt.svg": "4Znx",
	"./fontawesome/border-style.svg": "Oeay",
	"./fontawesome/border-top.svg": "1uqy",
	"./fontawesome/bow-arrow.svg": "gI3H",
	"./fontawesome/bowling-ball.svg": "HaWf",
	"./fontawesome/bowling-pins.svg": "CWtF",
	"./fontawesome/box-alt.svg": "k307",
	"./fontawesome/box-ballot.svg": "Wgq7",
	"./fontawesome/box-check.svg": "raTk",
	"./fontawesome/box-fragile.svg": "SbLt",
	"./fontawesome/box-full.svg": "uANo",
	"./fontawesome/box-heart.svg": "6m7W",
	"./fontawesome/box-open.svg": "cvwj",
	"./fontawesome/box-tissue.svg": "bjPF",
	"./fontawesome/box-up.svg": "+ph8",
	"./fontawesome/box-usd.svg": "rshB",
	"./fontawesome/box.svg": "YJbq",
	"./fontawesome/boxes-alt.svg": "npuo",
	"./fontawesome/boxes.svg": "m3yG",
	"./fontawesome/boxing-glove.svg": "rlZp",
	"./fontawesome/brackets-curly.svg": "RsHY",
	"./fontawesome/brackets.svg": "hiYL",
	"./fontawesome/braille.svg": "/LPw",
	"./fontawesome/brain.svg": "jsOM",
	"./fontawesome/bread-loaf.svg": "+zxz",
	"./fontawesome/bread-slice.svg": "s2OG",
	"./fontawesome/briefcase-medical.svg": "0Ahr",
	"./fontawesome/briefcase.svg": "Qd+Q",
	"./fontawesome/bring-forward.svg": "HvN4",
	"./fontawesome/bring-front.svg": "HeN7",
	"./fontawesome/broadcast-tower.svg": "hchv",
	"./fontawesome/broom.svg": "iJ3J",
	"./fontawesome/browser.svg": "MDlY",
	"./fontawesome/brush.svg": "5Z7i",
	"./fontawesome/bug.svg": "40DU",
	"./fontawesome/building.svg": "1y2F",
	"./fontawesome/bullhorn.svg": "ii4H",
	"./fontawesome/bullseye-arrow.svg": "tvyD",
	"./fontawesome/bullseye-pointer.svg": "wG+O",
	"./fontawesome/bullseye.svg": "yKQk",
	"./fontawesome/burger-soda.svg": "XFBl",
	"./fontawesome/burn.svg": "JAld",
	"./fontawesome/burrito.svg": "atJr",
	"./fontawesome/bus-alt.svg": "obes",
	"./fontawesome/bus-school.svg": "h7kV",
	"./fontawesome/bus.svg": "GqpK",
	"./fontawesome/business-time.svg": "xQ6a",
	"./fontawesome/cabinet-filing.svg": "Y22y",
	"./fontawesome/cactus.svg": "epHT",
	"./fontawesome/calculator-alt.svg": "o7P6",
	"./fontawesome/calculator.svg": "m31V",
	"./fontawesome/calendar-alt.svg": "q5S7",
	"./fontawesome/calendar-check.svg": "I701",
	"./fontawesome/calendar-day.svg": "8AKW",
	"./fontawesome/calendar-edit.svg": "AJMS",
	"./fontawesome/calendar-exclamation.svg": "TqB5",
	"./fontawesome/calendar-minus.svg": "8iBO",
	"./fontawesome/calendar-plus.svg": "eQWC",
	"./fontawesome/calendar-star.svg": "9FIK",
	"./fontawesome/calendar-times.svg": "0zZn",
	"./fontawesome/calendar-week.svg": "MvAA",
	"./fontawesome/calendar.svg": "sJDr",
	"./fontawesome/camcorder.svg": "iVAp",
	"./fontawesome/camera-alt.svg": "TNUu",
	"./fontawesome/camera-home.svg": "7/mi",
	"./fontawesome/camera-movie.svg": "6V79",
	"./fontawesome/camera-polaroid.svg": "zu9U",
	"./fontawesome/camera-retro.svg": "BlZK",
	"./fontawesome/camera.svg": "jcLx",
	"./fontawesome/campfire.svg": "8XTi",
	"./fontawesome/campground.svg": "nqVI",
	"./fontawesome/candle-holder.svg": "8EOR",
	"./fontawesome/candy-cane.svg": "bZMH",
	"./fontawesome/candy-corn.svg": "pYaT",
	"./fontawesome/cannabis.svg": "lp+c",
	"./fontawesome/capsules.svg": "qv1C",
	"./fontawesome/car-alt.svg": "Yfpq",
	"./fontawesome/car-battery.svg": "9bye",
	"./fontawesome/car-building.svg": "n9Pg",
	"./fontawesome/car-bump.svg": "lByV",
	"./fontawesome/car-bus.svg": "1H/I",
	"./fontawesome/car-crash.svg": "f607",
	"./fontawesome/car-garage.svg": "yk4w",
	"./fontawesome/car-mechanic.svg": "TrWE",
	"./fontawesome/car-side.svg": "6+PL",
	"./fontawesome/car-tilt.svg": "htIV",
	"./fontawesome/car-wash.svg": "V9dN",
	"./fontawesome/car.svg": "glAh",
	"./fontawesome/caravan-alt.svg": "M8qb",
	"./fontawesome/caravan.svg": "d16G",
	"./fontawesome/caret-circle-down.svg": "GBJN",
	"./fontawesome/caret-circle-left.svg": "l9FA",
	"./fontawesome/caret-circle-right.svg": "1MqJ",
	"./fontawesome/caret-circle-up.svg": "lSar",
	"./fontawesome/caret-down.svg": "U455",
	"./fontawesome/caret-left.svg": "KYMd",
	"./fontawesome/caret-right.svg": "e02E",
	"./fontawesome/caret-square-down.svg": "T05x",
	"./fontawesome/caret-square-left.svg": "PDIo",
	"./fontawesome/caret-square-right.svg": "9VoS",
	"./fontawesome/caret-square-up.svg": "5PEf",
	"./fontawesome/caret-up.svg": "O3VQ",
	"./fontawesome/carrot.svg": "IVqq",
	"./fontawesome/cars.svg": "u6mI",
	"./fontawesome/cart-arrow-down.svg": "qvvF",
	"./fontawesome/cart-plus.svg": "ZOcS",
	"./fontawesome/cash-register.svg": "hFMZ",
	"./fontawesome/cassette-tape.svg": "rlWG",
	"./fontawesome/cat-space.svg": "qE7f",
	"./fontawesome/cat.svg": "UuHF",
	"./fontawesome/cauldron.svg": "v99p",
	"./fontawesome/cctv.svg": "z13d",
	"./fontawesome/certificate.svg": "WklL",
	"./fontawesome/chair-office.svg": "W8Jc",
	"./fontawesome/chair.svg": "MVjU",
	"./fontawesome/chalkboard-teacher.svg": "PHsC",
	"./fontawesome/chalkboard.svg": "YV1w",
	"./fontawesome/charging-station.svg": "OttF",
	"./fontawesome/chart-area.svg": "q49Z",
	"./fontawesome/chart-bar.svg": "XpJM",
	"./fontawesome/chart-line-down.svg": "J4xV",
	"./fontawesome/chart-line.svg": "7R69",
	"./fontawesome/chart-network.svg": "Ubzu",
	"./fontawesome/chart-pie-alt.svg": "dz9/",
	"./fontawesome/chart-pie.svg": "9VUl",
	"./fontawesome/chart-scatter.svg": "0kBB",
	"./fontawesome/check-circle.svg": "zOpf",
	"./fontawesome/check-double.svg": "mZKP",
	"./fontawesome/check-square.svg": "uHj1",
	"./fontawesome/check.svg": "Qzuz",
	"./fontawesome/cheese-swiss.svg": "sYhY",
	"./fontawesome/cheese.svg": "QD+0",
	"./fontawesome/cheeseburger.svg": "3Jf6",
	"./fontawesome/chess-bishop-alt.svg": "9xSG",
	"./fontawesome/chess-bishop.svg": "cMcg",
	"./fontawesome/chess-board.svg": "YZS7",
	"./fontawesome/chess-clock-alt.svg": "4nV8",
	"./fontawesome/chess-clock.svg": "9Ex+",
	"./fontawesome/chess-king-alt.svg": "uXig",
	"./fontawesome/chess-king.svg": "dwCq",
	"./fontawesome/chess-knight-alt.svg": "ghS5",
	"./fontawesome/chess-knight.svg": "Dbft",
	"./fontawesome/chess-pawn-alt.svg": "MVQ6",
	"./fontawesome/chess-pawn.svg": "CWcS",
	"./fontawesome/chess-queen-alt.svg": "oG75",
	"./fontawesome/chess-queen.svg": "Y6NF",
	"./fontawesome/chess-rook-alt.svg": "Zpre",
	"./fontawesome/chess-rook.svg": "NUGt",
	"./fontawesome/chess.svg": "h08Q",
	"./fontawesome/chevron-circle-down.svg": "E+74",
	"./fontawesome/chevron-circle-left.svg": "tSLc",
	"./fontawesome/chevron-circle-right.svg": "8pin",
	"./fontawesome/chevron-circle-up.svg": "WFFk",
	"./fontawesome/chevron-double-down.svg": "+WmE",
	"./fontawesome/chevron-double-left.svg": "HMkf",
	"./fontawesome/chevron-double-right.svg": "rtpB",
	"./fontawesome/chevron-double-up.svg": "GrOK",
	"./fontawesome/chevron-down.svg": "vwnp",
	"./fontawesome/chevron-left.svg": "3XcG",
	"./fontawesome/chevron-right.svg": "DrLg",
	"./fontawesome/chevron-square-down.svg": "OYSH",
	"./fontawesome/chevron-square-left.svg": "bqLQ",
	"./fontawesome/chevron-square-right.svg": "Oow9",
	"./fontawesome/chevron-square-up.svg": "Td4u",
	"./fontawesome/chevron-up.svg": "A6mw",
	"./fontawesome/child.svg": "xgtt",
	"./fontawesome/chimney.svg": "FawG",
	"./fontawesome/church.svg": "O2I8",
	"./fontawesome/circle-notch.svg": "bg6c",
	"./fontawesome/circle.svg": "/6BY",
	"./fontawesome/city.svg": "2mNb",
	"./fontawesome/clarinet.svg": "WEYd",
	"./fontawesome/claw-marks.svg": "O00P",
	"./fontawesome/clinic-medical.svg": "2hHh",
	"./fontawesome/clipboard-check.svg": "8P54",
	"./fontawesome/clipboard-list-check.svg": "LkRK",
	"./fontawesome/clipboard-list.svg": "bXNt",
	"./fontawesome/clipboard-prescription.svg": "e1G3",
	"./fontawesome/clipboard-user.svg": "1zrT",
	"./fontawesome/clipboard.svg": "M9QQ",
	"./fontawesome/clock.svg": "fFPN",
	"./fontawesome/clone.svg": "Ssmd",
	"./fontawesome/closed-captioning.svg": "/YqT",
	"./fontawesome/cloud-download-alt.svg": "PIo6",
	"./fontawesome/cloud-download.svg": "nCyb",
	"./fontawesome/cloud-drizzle.svg": "W/FY",
	"./fontawesome/cloud-hail-mixed.svg": "/cyK",
	"./fontawesome/cloud-hail.svg": "4ABy",
	"./fontawesome/cloud-meatball.svg": "kO1J",
	"./fontawesome/cloud-moon-rain.svg": "7Y6l",
	"./fontawesome/cloud-moon.svg": "9v8n",
	"./fontawesome/cloud-music.svg": "2Ozd",
	"./fontawesome/cloud-rain.svg": "EFsz",
	"./fontawesome/cloud-rainbow.svg": "MgG6",
	"./fontawesome/cloud-showers-heavy.svg": "IgCb",
	"./fontawesome/cloud-showers.svg": "THKC",
	"./fontawesome/cloud-sleet.svg": "I4zc",
	"./fontawesome/cloud-snow.svg": "GGqG",
	"./fontawesome/cloud-sun-rain.svg": "rOEq",
	"./fontawesome/cloud-sun.svg": "WH9P",
	"./fontawesome/cloud-upload-alt.svg": "fuc6",
	"./fontawesome/cloud-upload.svg": "PtNS",
	"./fontawesome/cloud.svg": "qNed",
	"./fontawesome/clouds-moon.svg": "tfST",
	"./fontawesome/clouds-sun.svg": "5BWm",
	"./fontawesome/clouds.svg": "wJ/R",
	"./fontawesome/club.svg": "ok5V",
	"./fontawesome/cocktail.svg": "YEg8",
	"./fontawesome/code-branch.svg": "kwqe",
	"./fontawesome/code-commit.svg": "x4Hd",
	"./fontawesome/code-merge.svg": "LVL2",
	"./fontawesome/code.svg": "DH44",
	"./fontawesome/coffee-pot.svg": "XfZI",
	"./fontawesome/coffee-togo.svg": "jQT0",
	"./fontawesome/coffee.svg": "f5I+",
	"./fontawesome/coffin-cross.svg": "hUKV",
	"./fontawesome/coffin.svg": "tugi",
	"./fontawesome/cog.svg": "zfAS",
	"./fontawesome/cogs.svg": "pU9q",
	"./fontawesome/coin.svg": "yfdJ",
	"./fontawesome/coins.svg": "Wb05",
	"./fontawesome/columns.svg": "SNCL",
	"./fontawesome/comet.svg": "wtFl",
	"./fontawesome/comment-alt-check.svg": "oX/4",
	"./fontawesome/comment-alt-dollar.svg": "O7vp",
	"./fontawesome/comment-alt-dots.svg": "/76k",
	"./fontawesome/comment-alt-edit.svg": "wHx3",
	"./fontawesome/comment-alt-exclamation.svg": "jrkn",
	"./fontawesome/comment-alt-lines.svg": "Oyor",
	"./fontawesome/comment-alt-medical.svg": "hHZ0",
	"./fontawesome/comment-alt-minus.svg": "4Pyw",
	"./fontawesome/comment-alt-music.svg": "Ozyv",
	"./fontawesome/comment-alt-plus.svg": "xYJs",
	"./fontawesome/comment-alt-slash.svg": "st8v",
	"./fontawesome/comment-alt-smile.svg": "hEg3",
	"./fontawesome/comment-alt-times.svg": "fFq5",
	"./fontawesome/comment-alt.svg": "w6FI",
	"./fontawesome/comment-check.svg": "Jd/6",
	"./fontawesome/comment-dollar.svg": "XVcE",
	"./fontawesome/comment-dots.svg": "R/34",
	"./fontawesome/comment-edit.svg": "mqBY",
	"./fontawesome/comment-exclamation.svg": "7b4n",
	"./fontawesome/comment-lines.svg": "tldO",
	"./fontawesome/comment-medical.svg": "AemW",
	"./fontawesome/comment-minus.svg": "5ui1",
	"./fontawesome/comment-music.svg": "FwXy",
	"./fontawesome/comment-plus.svg": "/igD",
	"./fontawesome/comment-slash.svg": "BFXf",
	"./fontawesome/comment-smile.svg": "MD8Z",
	"./fontawesome/comment-times.svg": "Go6t",
	"./fontawesome/comment.svg": "M7AA",
	"./fontawesome/comments-alt-dollar.svg": "TFBM",
	"./fontawesome/comments-alt.svg": "bE+C",
	"./fontawesome/comments-dollar.svg": "JT5g",
	"./fontawesome/comments.svg": "sxo9",
	"./fontawesome/compact-disc.svg": "mW+I",
	"./fontawesome/compass-slash.svg": "mMKt",
	"./fontawesome/compass.svg": "4gnN",
	"./fontawesome/compress-alt.svg": "1opV",
	"./fontawesome/compress-arrows-alt.svg": "cmVA",
	"./fontawesome/compress-wide.svg": "VxVL",
	"./fontawesome/compress.svg": "ZJz0",
	"./fontawesome/computer-classic.svg": "/Bng",
	"./fontawesome/computer-speaker.svg": "dT2Q",
	"./fontawesome/concierge-bell.svg": "eMMd",
	"./fontawesome/construction.svg": "Wr55",
	"./fontawesome/container-storage.svg": "A2sL",
	"./fontawesome/conveyor-belt-alt.svg": "XrqM",
	"./fontawesome/conveyor-belt.svg": "458r",
	"./fontawesome/cookie-bite.svg": "jwUe",
	"./fontawesome/cookie.svg": "uWra",
	"./fontawesome/copy.svg": "SekD",
	"./fontawesome/copyright.svg": "NTkG",
	"./fontawesome/corn.svg": "ol3T",
	"./fontawesome/couch.svg": "XMx4",
	"./fontawesome/cow.svg": "aZzJ",
	"./fontawesome/cowbell-more.svg": "RY7v",
	"./fontawesome/cowbell.svg": "2Lh5",
	"./fontawesome/credit-card-blank.svg": "Hyms",
	"./fontawesome/credit-card-front.svg": "Y2gA",
	"./fontawesome/credit-card.svg": "P+Lh",
	"./fontawesome/cricket.svg": "nKKp",
	"./fontawesome/croissant.svg": "35gw",
	"./fontawesome/crop-alt.svg": "PZs1",
	"./fontawesome/crop.svg": "UcoM",
	"./fontawesome/cross.svg": "d25j",
	"./fontawesome/crosshairs.svg": "Ax98",
	"./fontawesome/crow.svg": "RpHk",
	"./fontawesome/crown.svg": "kqC3",
	"./fontawesome/crutch.svg": "s7Rc",
	"./fontawesome/crutches.svg": "8u6o",
	"./fontawesome/cube.svg": "WBa0",
	"./fontawesome/cubes.svg": "Gk+K",
	"./fontawesome/curling.svg": "glIb",
	"./fontawesome/cut.svg": "NRId",
	"./fontawesome/dagger.svg": "ZwxF",
	"./fontawesome/database.svg": "xXS+",
	"./fontawesome/deaf.svg": "DXAB",
	"./fontawesome/debug.svg": "6b4e",
	"./fontawesome/deer-rudolph.svg": "LJNY",
	"./fontawesome/deer.svg": "KlOt",
	"./fontawesome/democrat.svg": "i1aT",
	"./fontawesome/desktop-alt.svg": "owf5",
	"./fontawesome/desktop.svg": "kSIj",
	"./fontawesome/dewpoint.svg": "aKKq",
	"./fontawesome/dharmachakra.svg": "LwVX",
	"./fontawesome/diagnoses.svg": "knaR",
	"./fontawesome/diamond.svg": "t1SZ",
	"./fontawesome/dice-d10.svg": "e5mL",
	"./fontawesome/dice-d12.svg": "BtI+",
	"./fontawesome/dice-d20.svg": "0EFI",
	"./fontawesome/dice-d4.svg": "5pfy",
	"./fontawesome/dice-d6.svg": "ZkR+",
	"./fontawesome/dice-d8.svg": "Ve1w",
	"./fontawesome/dice-five.svg": "SAdy",
	"./fontawesome/dice-four.svg": "QmqI",
	"./fontawesome/dice-one.svg": "EJKs",
	"./fontawesome/dice-six.svg": "qfnh",
	"./fontawesome/dice-three.svg": "Gsy9",
	"./fontawesome/dice-two.svg": "x/JH",
	"./fontawesome/dice.svg": "lVM1",
	"./fontawesome/digging.svg": "9p9y",
	"./fontawesome/digital-tachograph.svg": "Owz9",
	"./fontawesome/diploma.svg": "6XDk",
	"./fontawesome/directions.svg": "xGqe",
	"./fontawesome/disc-drive.svg": "8yGv",
	"./fontawesome/disease.svg": "KB1n",
	"./fontawesome/divide.svg": "OuXF",
	"./fontawesome/dizzy.svg": "GIHu",
	"./fontawesome/dna.svg": "2PMT",
	"./fontawesome/do-not-enter.svg": "NEyl",
	"./fontawesome/dog-leashed.svg": "hnvm",
	"./fontawesome/dog.svg": "RWQs",
	"./fontawesome/dollar-sign.svg": "5yKT",
	"./fontawesome/dolly-empty.svg": "IviX",
	"./fontawesome/dolly-flatbed-alt.svg": "ewaR",
	"./fontawesome/dolly-flatbed-empty.svg": "HFQ8",
	"./fontawesome/dolly-flatbed.svg": "CGkG",
	"./fontawesome/dolly.svg": "ER/P",
	"./fontawesome/donate.svg": "ZGhF",
	"./fontawesome/door-closed.svg": "dWlu",
	"./fontawesome/door-open.svg": "buvQ",
	"./fontawesome/dot-circle.svg": "cUnR",
	"./fontawesome/dove.svg": "7/yI",
	"./fontawesome/download.svg": "dD6Q",
	"./fontawesome/drafting-compass.svg": "FT7w",
	"./fontawesome/dragon.svg": "IR2t",
	"./fontawesome/draw-circle.svg": "6zrQ",
	"./fontawesome/draw-polygon.svg": "oF2s",
	"./fontawesome/draw-square.svg": "2rss",
	"./fontawesome/dreidel.svg": "yr7V",
	"./fontawesome/drone-alt.svg": "oYUe",
	"./fontawesome/drone.svg": "Q+MO",
	"./fontawesome/drum-steelpan.svg": "tdGm",
	"./fontawesome/drum.svg": "+wPa",
	"./fontawesome/drumstick-bite.svg": "mBXZ",
	"./fontawesome/drumstick.svg": "4ATy",
	"./fontawesome/dryer-alt.svg": "/Vj/",
	"./fontawesome/dryer.svg": "CsHv",
	"./fontawesome/duck.svg": "PGvs",
	"./fontawesome/dumbbell.svg": "LCvq",
	"./fontawesome/dumpster-fire.svg": "NEvC",
	"./fontawesome/dumpster.svg": "xFdz",
	"./fontawesome/dungeon.svg": "Ei8/",
	"./fontawesome/ear-muffs.svg": "rd5C",
	"./fontawesome/ear.svg": "Vs3k",
	"./fontawesome/eclipse-alt.svg": "ACse",
	"./fontawesome/eclipse.svg": "P3YD",
	"./fontawesome/edit.svg": "j1SS",
	"./fontawesome/egg-fried.svg": "bdze",
	"./fontawesome/egg.svg": "sHUK",
	"./fontawesome/eject.svg": "6XhG",
	"./fontawesome/elephant.svg": "2+ux",
	"./fontawesome/ellipsis-h-alt.svg": "VTww",
	"./fontawesome/ellipsis-h.svg": "93bd",
	"./fontawesome/ellipsis-v-alt.svg": "XCZ4",
	"./fontawesome/ellipsis-v.svg": "MtPS",
	"./fontawesome/empty-set.svg": "beQJ",
	"./fontawesome/engine-warning.svg": "ZgXZ",
	"./fontawesome/envelope-open-dollar.svg": "4ZCI",
	"./fontawesome/envelope-open-text.svg": "o5W2",
	"./fontawesome/envelope-open.svg": "ByZc",
	"./fontawesome/envelope-square.svg": "ZEmo",
	"./fontawesome/envelope.svg": "xCV/",
	"./fontawesome/equals.svg": "Rk/b",
	"./fontawesome/eraser.svg": "6Zr5",
	"./fontawesome/ethernet.svg": "BfZ6",
	"./fontawesome/euro-sign.svg": "Szvf",
	"./fontawesome/exchange-alt.svg": "090t",
	"./fontawesome/exchange.svg": "43Rj",
	"./fontawesome/exclamation-circle.svg": "kTPz",
	"./fontawesome/exclamation-square.svg": "TD/P",
	"./fontawesome/exclamation-triangle.svg": "y3uL",
	"./fontawesome/exclamation.svg": "Wgl/",
	"./fontawesome/expand-alt.svg": "IBQe",
	"./fontawesome/expand-arrows-alt.svg": "RIWP",
	"./fontawesome/expand-arrows.svg": "qgUD",
	"./fontawesome/expand-wide.svg": "yYbD",
	"./fontawesome/expand.svg": "4/r9",
	"./fontawesome/external-link-alt.svg": "QC31",
	"./fontawesome/external-link-square-alt.svg": "hs7p",
	"./fontawesome/external-link-square.svg": "/uaf",
	"./fontawesome/external-link.svg": "eQ0Q",
	"./fontawesome/eye-dropper.svg": "oz1B",
	"./fontawesome/eye-evil.svg": "PIQq",
	"./fontawesome/eye-slash.svg": "uzNG",
	"./fontawesome/eye.svg": "ry7M",
	"./fontawesome/fan-table.svg": "/NwQ",
	"./fontawesome/fan.svg": "oN0v",
	"./fontawesome/farm.svg": "dTxg",
	"./fontawesome/fast-backward.svg": "L/UG",
	"./fontawesome/fast-forward.svg": "Lzff",
	"./fontawesome/faucet-drip.svg": "HMBf",
	"./fontawesome/faucet.svg": "6zbK",
	"./fontawesome/fax.svg": "boAC",
	"./fontawesome/feather-alt.svg": "UsRy",
	"./fontawesome/feather.svg": "jXxU",
	"./fontawesome/female.svg": "GdXC",
	"./fontawesome/field-hockey.svg": "Zxzy",
	"./fontawesome/fighter-jet.svg": "wVvd",
	"./fontawesome/file-alt.svg": "+vKD",
	"./fontawesome/file-archive.svg": "gfOI",
	"./fontawesome/file-audio.svg": "Dno2",
	"./fontawesome/file-certificate.svg": "hfhc",
	"./fontawesome/file-chart-line.svg": "Hsx/",
	"./fontawesome/file-chart-pie.svg": "/UgF",
	"./fontawesome/file-check.svg": "wKP8",
	"./fontawesome/file-code.svg": "pakL",
	"./fontawesome/file-contract.svg": "KMCO",
	"./fontawesome/file-csv.svg": "83Kw",
	"./fontawesome/file-download.svg": "iE6k",
	"./fontawesome/file-edit.svg": "pDmU",
	"./fontawesome/file-excel.svg": "9Hnd",
	"./fontawesome/file-exclamation.svg": "EHdC",
	"./fontawesome/file-export.svg": "r7wE",
	"./fontawesome/file-image.svg": "DwfK",
	"./fontawesome/file-import.svg": "7HeT",
	"./fontawesome/file-invoice-dollar.svg": "J6xI",
	"./fontawesome/file-invoice.svg": "a++a",
	"./fontawesome/file-medical-alt.svg": "UL0a",
	"./fontawesome/file-medical.svg": "8sjR",
	"./fontawesome/file-minus.svg": "xEiH",
	"./fontawesome/file-music.svg": "ovFh",
	"./fontawesome/file-pdf.svg": "0xQX",
	"./fontawesome/file-plus.svg": "aVF/",
	"./fontawesome/file-powerpoint.svg": "2oYx",
	"./fontawesome/file-prescription.svg": "LqPM",
	"./fontawesome/file-search.svg": "Ke9F",
	"./fontawesome/file-signature.svg": "7Fvb",
	"./fontawesome/file-spreadsheet.svg": "zDjz",
	"./fontawesome/file-times.svg": "WkC8",
	"./fontawesome/file-upload.svg": "fBH1",
	"./fontawesome/file-user.svg": "ACDb",
	"./fontawesome/file-video.svg": "ZHRz",
	"./fontawesome/file-word.svg": "dAew",
	"./fontawesome/file.svg": "CP3r",
	"./fontawesome/files-medical.svg": "Wrw3",
	"./fontawesome/fill-drip.svg": "4Ck+",
	"./fontawesome/fill.svg": "wOhg",
	"./fontawesome/film-alt.svg": "CP3Z",
	"./fontawesome/film-canister.svg": "nfbR",
	"./fontawesome/film.svg": "B4Rn",
	"./fontawesome/filter.svg": "mAFi",
	"./fontawesome/fingerprint.svg": "Uwqt",
	"./fontawesome/fire-alt.svg": "6mql",
	"./fontawesome/fire-extinguisher.svg": "Hme2",
	"./fontawesome/fire-smoke.svg": "Ln5S",
	"./fontawesome/fire.svg": "yVjt",
	"./fontawesome/fireplace.svg": "SBq/",
	"./fontawesome/first-aid.svg": "PyAK",
	"./fontawesome/fish-cooked.svg": "KoZm",
	"./fontawesome/fish.svg": "5A9d",
	"./fontawesome/fist-raised.svg": "oGDz",
	"./fontawesome/flag-alt.svg": "+Fr8",
	"./fontawesome/flag-checkered.svg": "oHoR",
	"./fontawesome/flag-usa.svg": "yONo",
	"./fontawesome/flag.svg": "ukbW",
	"./fontawesome/flame.svg": "WwcM",
	"./fontawesome/flashlight.svg": "cnFa",
	"./fontawesome/flask-poison.svg": "lpOs",
	"./fontawesome/flask-potion.svg": "XDml",
	"./fontawesome/flask.svg": "3gI6",
	"./fontawesome/flower-daffodil.svg": "3Fhy",
	"./fontawesome/flower-tulip.svg": "QlDd",
	"./fontawesome/flower.svg": "Vt0n",
	"./fontawesome/flushed.svg": "7O/o",
	"./fontawesome/flute.svg": "1bxO",
	"./fontawesome/flux-capacitor.svg": "dRzm",
	"./fontawesome/fog.svg": "vvjA",
	"./fontawesome/folder-download.svg": "jZjc",
	"./fontawesome/folder-minus.svg": "vBjJ",
	"./fontawesome/folder-open.svg": "EV84",
	"./fontawesome/folder-plus.svg": "khtk",
	"./fontawesome/folder-times.svg": "JQ3W",
	"./fontawesome/folder-tree.svg": "uHVe",
	"./fontawesome/folder-upload.svg": "scWD",
	"./fontawesome/folder.svg": "YSrJ",
	"./fontawesome/folders.svg": "hXz3",
	"./fontawesome/font-awesome-logo-full.svg": "z36F",
	"./fontawesome/font-case.svg": "TvPb",
	"./fontawesome/font.svg": "Hs/C",
	"./fontawesome/football-ball.svg": "XxjC",
	"./fontawesome/football-helmet.svg": "lVzi",
	"./fontawesome/forklift.svg": "sPjK",
	"./fontawesome/forward.svg": "1vZN",
	"./fontawesome/fragile.svg": "TBy1",
	"./fontawesome/french-fries.svg": "aCT1",
	"./fontawesome/frog.svg": "W4yh",
	"./fontawesome/frosty-head.svg": "AzRj",
	"./fontawesome/frown-open.svg": "5m7Y",
	"./fontawesome/frown.svg": "uQob",
	"./fontawesome/function.svg": "17HB",
	"./fontawesome/funnel-dollar.svg": "+j7M",
	"./fontawesome/futbol.svg": "FLV+",
	"./fontawesome/galaxy.svg": "T23j",
	"./fontawesome/game-board-alt.svg": "R1dW",
	"./fontawesome/game-board.svg": "Za1O",
	"./fontawesome/game-console-handheld.svg": "rWB+",
	"./fontawesome/gamepad-alt.svg": "qVBz",
	"./fontawesome/gamepad.svg": "S7pb",
	"./fontawesome/garage-car.svg": "zJoZ",
	"./fontawesome/garage-open.svg": "CsNs",
	"./fontawesome/garage.svg": "rJ+Z",
	"./fontawesome/gas-pump-slash.svg": "ErT7",
	"./fontawesome/gas-pump.svg": "bvuK",
	"./fontawesome/gavel.svg": "V6DR",
	"./fontawesome/gem.svg": "RJF1",
	"./fontawesome/genderless.svg": "6tTl",
	"./fontawesome/ghost.svg": "Igd7",
	"./fontawesome/gift-card.svg": "eSa4",
	"./fontawesome/gift.svg": "2HB3",
	"./fontawesome/gifts.svg": "pOOW",
	"./fontawesome/gingerbread-man.svg": "DFja",
	"./fontawesome/glass-champagne.svg": "GuU9",
	"./fontawesome/glass-cheers.svg": "iuDm",
	"./fontawesome/glass-citrus.svg": "g4Cu",
	"./fontawesome/glass-martini-alt.svg": "UaTw",
	"./fontawesome/glass-martini.svg": "hshf",
	"./fontawesome/glass-whiskey-rocks.svg": "aQFj",
	"./fontawesome/glass-whiskey.svg": "Z86t",
	"./fontawesome/glass.svg": "adlk",
	"./fontawesome/glasses-alt.svg": "+LNP",
	"./fontawesome/glasses.svg": "TvzR",
	"./fontawesome/globe-africa.svg": "zgjC",
	"./fontawesome/globe-americas.svg": "p8Qb",
	"./fontawesome/globe-asia.svg": "9kB5",
	"./fontawesome/globe-europe.svg": "C8T+",
	"./fontawesome/globe-snow.svg": "dXrv",
	"./fontawesome/globe-stand.svg": "pDj+",
	"./fontawesome/globe.svg": "NKl+",
	"./fontawesome/golf-ball.svg": "/5Px",
	"./fontawesome/golf-club.svg": "5mCg",
	"./fontawesome/gopuram.svg": "bMxB",
	"./fontawesome/graduation-cap.svg": "OXhg",
	"./fontawesome/gramophone.svg": "GLEw",
	"./fontawesome/greater-than-equal.svg": "OjNd",
	"./fontawesome/greater-than.svg": "xmAe",
	"./fontawesome/grimace.svg": "X8cA",
	"./fontawesome/grin-alt.svg": "Crs7",
	"./fontawesome/grin-beam-sweat.svg": "C/w2",
	"./fontawesome/grin-beam.svg": "B2G9",
	"./fontawesome/grin-hearts.svg": "uJtp",
	"./fontawesome/grin-squint-tears.svg": "/ErV",
	"./fontawesome/grin-squint.svg": "mGXN",
	"./fontawesome/grin-stars.svg": "XkGw",
	"./fontawesome/grin-tears.svg": "fzQo",
	"./fontawesome/grin-tongue-squint.svg": "AMAo",
	"./fontawesome/grin-tongue-wink.svg": "QpCy",
	"./fontawesome/grin-tongue.svg": "cP3S",
	"./fontawesome/grin-wink.svg": "jPsh",
	"./fontawesome/grin.svg": "1xVs",
	"./fontawesome/grip-horizontal.svg": "2Um4",
	"./fontawesome/grip-lines-vertical.svg": "nIV8",
	"./fontawesome/grip-lines.svg": "38bp",
	"./fontawesome/grip-vertical.svg": "bBaY",
	"./fontawesome/guitar-electric.svg": "T0CD",
	"./fontawesome/guitar.svg": "jgax",
	"./fontawesome/guitars.svg": "LG+J",
	"./fontawesome/h-square.svg": "vEn/",
	"./fontawesome/h1.svg": "uzcl",
	"./fontawesome/h2.svg": "pbVs",
	"./fontawesome/h3.svg": "MyFL",
	"./fontawesome/h4.svg": "MQoK",
	"./fontawesome/hamburger.svg": "8shx",
	"./fontawesome/hammer-war.svg": "SZCE",
	"./fontawesome/hammer.svg": "cLO7",
	"./fontawesome/hamsa.svg": "Qug+",
	"./fontawesome/hand-heart.svg": "Fock",
	"./fontawesome/hand-holding-box.svg": "Fzi0",
	"./fontawesome/hand-holding-heart.svg": "Sqio",
	"./fontawesome/hand-holding-magic.svg": "h+Um",
	"./fontawesome/hand-holding-medical.svg": "Kujb",
	"./fontawesome/hand-holding-seedling.svg": "upSa",
	"./fontawesome/hand-holding-usd.svg": "UwhR",
	"./fontawesome/hand-holding-water.svg": "ZtyS",
	"./fontawesome/hand-holding.svg": "9YiC",
	"./fontawesome/hand-lizard.svg": "nRtt",
	"./fontawesome/hand-middle-finger.svg": "odMR",
	"./fontawesome/hand-paper.svg": "vTxL",
	"./fontawesome/hand-peace.svg": "Esaj",
	"./fontawesome/hand-point-down.svg": "rWID",
	"./fontawesome/hand-point-left.svg": "kg+1",
	"./fontawesome/hand-point-right.svg": "NbwZ",
	"./fontawesome/hand-point-up.svg": "oZW5",
	"./fontawesome/hand-pointer.svg": "Rrv9",
	"./fontawesome/hand-receiving.svg": "kOOb",
	"./fontawesome/hand-rock.svg": "nmOp",
	"./fontawesome/hand-scissors.svg": "v3/g",
	"./fontawesome/hand-sparkles.svg": "P5s2",
	"./fontawesome/hand-spock.svg": "604Y",
	"./fontawesome/hands-heart.svg": "FY6i",
	"./fontawesome/hands-helping.svg": "qvM9",
	"./fontawesome/hands-usd.svg": "NAta",
	"./fontawesome/hands-wash.svg": "D8qB",
	"./fontawesome/hands.svg": "kpPh",
	"./fontawesome/handshake-alt-slash.svg": "h0nF",
	"./fontawesome/handshake-alt.svg": "bt2Z",
	"./fontawesome/handshake-slash.svg": "u4BL",
	"./fontawesome/handshake.svg": "VWez",
	"./fontawesome/hanukiah.svg": "bcEV",
	"./fontawesome/hard-hat.svg": "xhDg",
	"./fontawesome/hashtag.svg": "pDAc",
	"./fontawesome/hat-chef.svg": "WGyK",
	"./fontawesome/hat-cowboy-side.svg": "SVtq",
	"./fontawesome/hat-cowboy.svg": "vNKM",
	"./fontawesome/hat-santa.svg": "ghwu",
	"./fontawesome/hat-winter.svg": "nIRK",
	"./fontawesome/hat-witch.svg": "X4Sd",
	"./fontawesome/hat-wizard.svg": "nGrp",
	"./fontawesome/hdd.svg": "StmM",
	"./fontawesome/head-side-brain.svg": "zz2d",
	"./fontawesome/head-side-cough-slash.svg": "Tpq9",
	"./fontawesome/head-side-cough.svg": "fhPq",
	"./fontawesome/head-side-headphones.svg": "4Qm0",
	"./fontawesome/head-side-mask.svg": "qOxC",
	"./fontawesome/head-side-medical.svg": "OEwj",
	"./fontawesome/head-side-virus.svg": "uE7E",
	"./fontawesome/head-side.svg": "0Z5d",
	"./fontawesome/head-vr.svg": "2P5+",
	"./fontawesome/heading.svg": "ViYI",
	"./fontawesome/headphones-alt.svg": "v/o1",
	"./fontawesome/headphones.svg": "eiC7",
	"./fontawesome/headset.svg": "Crhg",
	"./fontawesome/heart-broken.svg": "m81g",
	"./fontawesome/heart-circle.svg": "12na",
	"./fontawesome/heart-rate.svg": "fBv3",
	"./fontawesome/heart-square.svg": "NsFE",
	"./fontawesome/heart.svg": "pLx0",
	"./fontawesome/heartbeat.svg": "vRNJ",
	"./fontawesome/heat.svg": "TJtt",
	"./fontawesome/helicopter.svg": "PSfp",
	"./fontawesome/helmet-battle.svg": "Lild",
	"./fontawesome/hexagon.svg": "hxcZ",
	"./fontawesome/highlighter.svg": "oZvG",
	"./fontawesome/hiking.svg": "Po5P",
	"./fontawesome/hippo.svg": "PRGP",
	"./fontawesome/history.svg": "6DeY",
	"./fontawesome/hockey-mask.svg": "rniF",
	"./fontawesome/hockey-puck.svg": "HICV",
	"./fontawesome/hockey-sticks.svg": "GLBH",
	"./fontawesome/holly-berry.svg": "75/u",
	"./fontawesome/home-alt.svg": "Y0bF",
	"./fontawesome/home-heart.svg": "B8sR",
	"./fontawesome/home-lg-alt.svg": "6gWo",
	"./fontawesome/home-lg.svg": "q8pw",
	"./fontawesome/home.svg": "7ddL",
	"./fontawesome/hood-cloak.svg": "4WYq",
	"./fontawesome/horizontal-rule.svg": "a8o4",
	"./fontawesome/horse-head.svg": "L2yQ",
	"./fontawesome/horse-saddle.svg": "PTs0",
	"./fontawesome/horse.svg": "LVk2",
	"./fontawesome/hospital-alt.svg": "n8DN",
	"./fontawesome/hospital-symbol.svg": "30F1",
	"./fontawesome/hospital-user.svg": "QmpU",
	"./fontawesome/hospital.svg": "SPzZ",
	"./fontawesome/hospitals.svg": "kHB4",
	"./fontawesome/hot-tub.svg": "aNbd",
	"./fontawesome/hotdog.svg": "xjjz",
	"./fontawesome/hotel.svg": "WC06",
	"./fontawesome/hourglass-end.svg": "r+ne",
	"./fontawesome/hourglass-half.svg": "0s4P",
	"./fontawesome/hourglass-start.svg": "QH5M",
	"./fontawesome/hourglass.svg": "Ou3u",
	"./fontawesome/house-damage.svg": "+1RU",
	"./fontawesome/house-day.svg": "G6xQ",
	"./fontawesome/house-flood.svg": "BKDX",
	"./fontawesome/house-leave.svg": "pd1O",
	"./fontawesome/house-night.svg": "YV0g",
	"./fontawesome/house-return.svg": "LBZs",
	"./fontawesome/house-signal.svg": "Wf0D",
	"./fontawesome/house-user.svg": "mkTU",
	"./fontawesome/house.svg": "bK0l",
	"./fontawesome/hryvnia.svg": "Ea0N",
	"./fontawesome/humidity.svg": "3e7s",
	"./fontawesome/hurricane.svg": "cbe7",
	"./fontawesome/i-cursor.svg": "XT36",
	"./fontawesome/ice-cream.svg": "zSYm",
	"./fontawesome/ice-skate.svg": "QZkh",
	"./fontawesome/icicles.svg": "C3YN",
	"./fontawesome/icons-alt.svg": "wrvX",
	"./fontawesome/icons.svg": "7MPP",
	"./fontawesome/id-badge.svg": "Odpf",
	"./fontawesome/id-card-alt.svg": "BQcu",
	"./fontawesome/id-card.svg": "2mJ1",
	"./fontawesome/igloo.svg": "Ohs8",
	"./fontawesome/image-polaroid.svg": "i2Uh",
	"./fontawesome/image.svg": "t/L4",
	"./fontawesome/images.svg": "7K8B",
	"./fontawesome/inbox-in.svg": "Y4V9",
	"./fontawesome/inbox-out.svg": "ycdI",
	"./fontawesome/inbox.svg": "O37S",
	"./fontawesome/indent.svg": "618j",
	"./fontawesome/industry-alt.svg": "tEVn",
	"./fontawesome/industry.svg": "FeXO",
	"./fontawesome/infinity.svg": "FoDd",
	"./fontawesome/info-circle.svg": "zSN1",
	"./fontawesome/info-square.svg": "dejE",
	"./fontawesome/info.svg": "rInu",
	"./fontawesome/inhaler.svg": "UQxO",
	"./fontawesome/integral.svg": "/+D4",
	"./fontawesome/intersection.svg": "B9s6",
	"./fontawesome/inventory.svg": "rilC",
	"./fontawesome/island-tropical.svg": "TzAe",
	"./fontawesome/italic.svg": "QJJ4",
	"./fontawesome/jack-o-lantern.svg": "1NHt",
	"./fontawesome/jedi.svg": "hzyK",
	"./fontawesome/joint.svg": "lizT",
	"./fontawesome/journal-whills.svg": "dgW9",
	"./fontawesome/joystick.svg": "3IVz",
	"./fontawesome/jug.svg": "IL2l",
	"./fontawesome/kaaba.svg": "nHQ4",
	"./fontawesome/kazoo.svg": "ckmY",
	"./fontawesome/kerning.svg": "STKU",
	"./fontawesome/key-skeleton.svg": "CDRM",
	"./fontawesome/key.svg": "ODa5",
	"./fontawesome/keyboard.svg": "QPNS",
	"./fontawesome/keynote.svg": "4bmM",
	"./fontawesome/khanda.svg": "j/p4",
	"./fontawesome/kidneys.svg": "WpaZ",
	"./fontawesome/kiss-beam.svg": "uRdT",
	"./fontawesome/kiss-wink-heart.svg": "BT39",
	"./fontawesome/kiss.svg": "UUNf",
	"./fontawesome/kite.svg": "5cEq",
	"./fontawesome/kiwi-bird.svg": "B67m",
	"./fontawesome/knife-kitchen.svg": "aE45",
	"./fontawesome/lambda.svg": "qZtv",
	"./fontawesome/lamp-desk.svg": "x6gl",
	"./fontawesome/lamp-floor.svg": "NkMG",
	"./fontawesome/lamp.svg": "3j9y",
	"./fontawesome/landmark-alt.svg": "dPNK",
	"./fontawesome/landmark.svg": "mmin",
	"./fontawesome/language.svg": "iNjE",
	"./fontawesome/laptop-code.svg": "fWoj",
	"./fontawesome/laptop-house.svg": "zwnR",
	"./fontawesome/laptop-medical.svg": "yDZe",
	"./fontawesome/laptop.svg": "vYp0",
	"./fontawesome/lasso.svg": "EMXF",
	"./fontawesome/laugh-beam.svg": "0YY+",
	"./fontawesome/laugh-squint.svg": "Gf9n",
	"./fontawesome/laugh-wink.svg": "92hW",
	"./fontawesome/laugh.svg": "cVPt",
	"./fontawesome/layer-group.svg": "SqGg",
	"./fontawesome/layer-minus.svg": "tab2",
	"./fontawesome/layer-plus.svg": "GWwv",
	"./fontawesome/leaf-heart.svg": "jHFk",
	"./fontawesome/leaf-maple.svg": "To47",
	"./fontawesome/leaf-oak.svg": "2xMo",
	"./fontawesome/leaf.svg": "WbKJ",
	"./fontawesome/lemon.svg": "fugO",
	"./fontawesome/less-than-equal.svg": "4PeE",
	"./fontawesome/less-than.svg": "sBf+",
	"./fontawesome/level-down-alt.svg": "if/8",
	"./fontawesome/level-down.svg": "gWa+",
	"./fontawesome/level-up-alt.svg": "Q++U",
	"./fontawesome/level-up.svg": "ujiR",
	"./fontawesome/life-ring.svg": "rUM3",
	"./fontawesome/light-ceiling.svg": "8A0J",
	"./fontawesome/light-switch-off.svg": "2s+H",
	"./fontawesome/light-switch-on.svg": "LhwN",
	"./fontawesome/light-switch.svg": "6/sh",
	"./fontawesome/lightbulb-dollar.svg": "X9lG",
	"./fontawesome/lightbulb-exclamation.svg": "Kc/e",
	"./fontawesome/lightbulb-on.svg": "jGFb",
	"./fontawesome/lightbulb-slash.svg": "2uWK",
	"./fontawesome/lightbulb.svg": "LUep",
	"./fontawesome/lights-holiday.svg": "Gczf",
	"./fontawesome/line-columns.svg": "JAVI",
	"./fontawesome/line-height.svg": "bJ2K",
	"./fontawesome/link.svg": "TRlh",
	"./fontawesome/lips.svg": "cHQS",
	"./fontawesome/lira-sign.svg": "E6gn",
	"./fontawesome/list-alt.svg": "SiYj",
	"./fontawesome/list-music.svg": "uWdY",
	"./fontawesome/list-ol.svg": "Ihbb",
	"./fontawesome/list-ul.svg": "r6gC",
	"./fontawesome/list.svg": "rWMD",
	"./fontawesome/location-arrow.svg": "m3T3",
	"./fontawesome/location-circle.svg": "gLjW",
	"./fontawesome/location-slash.svg": "LaOR",
	"./fontawesome/location.svg": "mtsp",
	"./fontawesome/lock-alt.svg": "xkMw",
	"./fontawesome/lock-open-alt.svg": "8hAg",
	"./fontawesome/lock-open.svg": "GyU4",
	"./fontawesome/lock.svg": "O1TG",
	"./fontawesome/long-arrow-alt-down.svg": "O7p5",
	"./fontawesome/long-arrow-alt-left.svg": "V4sb",
	"./fontawesome/long-arrow-alt-right.svg": "UCDZ",
	"./fontawesome/long-arrow-alt-up.svg": "aZIs",
	"./fontawesome/long-arrow-down.svg": "gydX",
	"./fontawesome/long-arrow-left.svg": "KN7h",
	"./fontawesome/long-arrow-right.svg": "SDbP",
	"./fontawesome/long-arrow-up.svg": "H8Rc",
	"./fontawesome/loveseat.svg": "772k",
	"./fontawesome/low-vision.svg": "j5XW",
	"./fontawesome/luchador.svg": "txTI",
	"./fontawesome/luggage-cart.svg": "m5BI",
	"./fontawesome/lungs-virus.svg": "nj0A",
	"./fontawesome/lungs.svg": "GXBx",
	"./fontawesome/mace.svg": "YUR0",
	"./fontawesome/magic.svg": "aZH2",
	"./fontawesome/magnet.svg": "lqr7",
	"./fontawesome/mail-bulk.svg": "HPa5",
	"./fontawesome/mailbox.svg": "wVhs",
	"./fontawesome/male.svg": "REoG",
	"./fontawesome/mandolin.svg": "1bKH",
	"./fontawesome/map-marked-alt.svg": "dKza",
	"./fontawesome/map-marked.svg": "+e62",
	"./fontawesome/map-marker-alt-slash.svg": "EsH7",
	"./fontawesome/map-marker-alt.svg": "h4k4",
	"./fontawesome/map-marker-check.svg": "8UMV",
	"./fontawesome/map-marker-edit.svg": "RMuM",
	"./fontawesome/map-marker-exclamation.svg": "x3m4",
	"./fontawesome/map-marker-minus.svg": "UTmi",
	"./fontawesome/map-marker-plus.svg": "xY6c",
	"./fontawesome/map-marker-question.svg": "LN86",
	"./fontawesome/map-marker-slash.svg": "qy8R",
	"./fontawesome/map-marker-smile.svg": "6rPQ",
	"./fontawesome/map-marker-times.svg": "BaIk",
	"./fontawesome/map-marker.svg": "nZDk",
	"./fontawesome/map-pin.svg": "eoGv",
	"./fontawesome/map-signs.svg": "+Ixh",
	"./fontawesome/map.svg": "FDgw",
	"./fontawesome/marker.svg": "+bxy",
	"./fontawesome/mars-double.svg": "IkuU",
	"./fontawesome/mars-stroke-h.svg": "8to8",
	"./fontawesome/mars-stroke-v.svg": "7Jub",
	"./fontawesome/mars-stroke.svg": "zjcV",
	"./fontawesome/mars.svg": "pe/u",
	"./fontawesome/mask.svg": "vVq+",
	"./fontawesome/meat.svg": "hbfP",
	"./fontawesome/medal.svg": "NCJ1",
	"./fontawesome/medkit.svg": "TnGz",
	"./fontawesome/megaphone.svg": "gFSo",
	"./fontawesome/meh-blank.svg": "eovt",
	"./fontawesome/meh-rolling-eyes.svg": "sq+V",
	"./fontawesome/meh.svg": "XBRD",
	"./fontawesome/memory.svg": "QL6e",
	"./fontawesome/menorah.svg": "5gI8",
	"./fontawesome/mercury.svg": "O/a6",
	"./fontawesome/meteor.svg": "seXA",
	"./fontawesome/microchip.svg": "o49/",
	"./fontawesome/microphone-alt-slash.svg": "Vx0f",
	"./fontawesome/microphone-alt.svg": "7wqt",
	"./fontawesome/microphone-slash.svg": "MUmG",
	"./fontawesome/microphone-stand.svg": "cBpd",
	"./fontawesome/microphone.svg": "cA/0",
	"./fontawesome/microscope.svg": "zhoV",
	"./fontawesome/microwave.svg": "fK+H",
	"./fontawesome/mind-share.svg": "5K+W",
	"./fontawesome/minus-circle.svg": "us29",
	"./fontawesome/minus-hexagon.svg": "fIBa",
	"./fontawesome/minus-octagon.svg": "tw1J",
	"./fontawesome/minus-square.svg": "Qg9u",
	"./fontawesome/minus.svg": "pWL+",
	"./fontawesome/mistletoe.svg": "XShN",
	"./fontawesome/mitten.svg": "JNCA",
	"./fontawesome/mobile-alt.svg": "GDXP",
	"./fontawesome/mobile-android-alt.svg": "cWxR",
	"./fontawesome/mobile-android.svg": "JJ7w",
	"./fontawesome/mobile.svg": "yF6I",
	"./fontawesome/money-bill-alt.svg": "wm8Y",
	"./fontawesome/money-bill-wave-alt.svg": "BMRK",
	"./fontawesome/money-bill-wave.svg": "42OP",
	"./fontawesome/money-bill.svg": "fsxE",
	"./fontawesome/money-check-alt.svg": "Yl4p",
	"./fontawesome/money-check-edit-alt.svg": "Q7fZ",
	"./fontawesome/money-check-edit.svg": "8/Z4",
	"./fontawesome/money-check.svg": "341b",
	"./fontawesome/monitor-heart-rate.svg": "5puQ",
	"./fontawesome/monkey.svg": "RYPf",
	"./fontawesome/monument.svg": "c3+z",
	"./fontawesome/moon-cloud.svg": "MNtK",
	"./fontawesome/moon-stars.svg": "gRON",
	"./fontawesome/moon.svg": "7/2g",
	"./fontawesome/mortar-pestle.svg": "Rdo4",
	"./fontawesome/mosque.svg": "nTnJ",
	"./fontawesome/motorcycle.svg": "ODQd",
	"./fontawesome/mountain.svg": "ZYLF",
	"./fontawesome/mountains.svg": "zxxC",
	"./fontawesome/mouse-alt.svg": "LXzo",
	"./fontawesome/mouse-pointer.svg": "rvMm",
	"./fontawesome/mouse.svg": "YR8N",
	"./fontawesome/mp3-player.svg": "60O0",
	"./fontawesome/mug-hot.svg": "WgE/",
	"./fontawesome/mug-marshmallows.svg": "Mv1g",
	"./fontawesome/mug-tea.svg": "gzyg",
	"./fontawesome/mug.svg": "4lMg",
	"./fontawesome/music-alt-slash.svg": "+r9q",
	"./fontawesome/music-alt.svg": "4T+v",
	"./fontawesome/music-slash.svg": "hdVq",
	"./fontawesome/music.svg": "8k34",
	"./fontawesome/narwhal.svg": "kBtJ",
	"./fontawesome/network-wired.svg": "QvX/",
	"./fontawesome/neuter.svg": "5aep",
	"./fontawesome/newspaper.svg": "HZvo",
	"./fontawesome/not-equal.svg": "rPTE",
	"./fontawesome/notes-medical.svg": "/RhB",
	"./fontawesome/object-group.svg": "IQJt",
	"./fontawesome/object-ungroup.svg": "lHLs",
	"./fontawesome/octagon.svg": "tOi7",
	"./fontawesome/oil-can.svg": "gL/D",
	"./fontawesome/oil-temp.svg": "AQd1",
	"./fontawesome/om.svg": "8Tqg",
	"./fontawesome/omega.svg": "ryFN",
	"./fontawesome/ornament.svg": "mWKV",
	"./fontawesome/otter.svg": "03RC",
	"./fontawesome/outdent.svg": "s5PI",
	"./fontawesome/outlet.svg": "3dYL",
	"./fontawesome/oven.svg": "eX79",
	"./fontawesome/overline.svg": "MRid",
	"./fontawesome/page-break.svg": "EsS3",
	"./fontawesome/pager.svg": "nrem",
	"./fontawesome/paint-brush-alt.svg": "QQvv",
	"./fontawesome/paint-brush.svg": "6fU1",
	"./fontawesome/paint-roller.svg": "ocVE",
	"./fontawesome/palette.svg": "BlKs",
	"./fontawesome/pallet-alt.svg": "0cAn",
	"./fontawesome/pallet.svg": "Ndte",
	"./fontawesome/paper-plane.svg": "Xk/0",
	"./fontawesome/paperclip.svg": "Nqy6",
	"./fontawesome/parachute-box.svg": "/xiL",
	"./fontawesome/paragraph-rtl.svg": "wO+N",
	"./fontawesome/paragraph.svg": "+YXx",
	"./fontawesome/parking-circle-slash.svg": "kelS",
	"./fontawesome/parking-circle.svg": "kbbb",
	"./fontawesome/parking-slash.svg": "rQ75",
	"./fontawesome/parking.svg": "JHg5",
	"./fontawesome/passport.svg": "dl4P",
	"./fontawesome/pastafarianism.svg": "5PRr",
	"./fontawesome/paste.svg": "Mqjm",
	"./fontawesome/pause-circle.svg": "4iwZ",
	"./fontawesome/pause.svg": "qqoU",
	"./fontawesome/paw-alt.svg": "JtWJ",
	"./fontawesome/paw-claws.svg": "dlOi",
	"./fontawesome/paw.svg": "hPt1",
	"./fontawesome/peace.svg": "W4eC",
	"./fontawesome/pegasus.svg": "MeHN",
	"./fontawesome/pen-alt.svg": "ZNsk",
	"./fontawesome/pen-fancy.svg": "8xq5",
	"./fontawesome/pen-nib.svg": "R1dm",
	"./fontawesome/pen-square.svg": "sbkg",
	"./fontawesome/pen.svg": "6x+H",
	"./fontawesome/pencil-alt.svg": "t69u",
	"./fontawesome/pencil-paintbrush.svg": "VVoR",
	"./fontawesome/pencil-ruler.svg": "qkhJ",
	"./fontawesome/pencil.svg": "Oii3",
	"./fontawesome/pennant.svg": "NEhJ",
	"./fontawesome/people-arrows.svg": "hfMp",
	"./fontawesome/people-carry.svg": "fnO6",
	"./fontawesome/pepper-hot.svg": "6Tn5",
	"./fontawesome/percent.svg": "UvBV",
	"./fontawesome/percentage.svg": "O1s2",
	"./fontawesome/person-booth.svg": "JH9q",
	"./fontawesome/person-carry.svg": "AGBK",
	"./fontawesome/person-dolly-empty.svg": "oloR",
	"./fontawesome/person-dolly.svg": "e6fN",
	"./fontawesome/person-sign.svg": "z+PH",
	"./fontawesome/phone-alt.svg": "U4Jr",
	"./fontawesome/phone-laptop.svg": "ey1n",
	"./fontawesome/phone-office.svg": "agAK",
	"./fontawesome/phone-plus.svg": "Axeg",
	"./fontawesome/phone-rotary.svg": "Sp36",
	"./fontawesome/phone-slash.svg": "qMYG",
	"./fontawesome/phone-square-alt.svg": "yN4h",
	"./fontawesome/phone-square.svg": "rT1F",
	"./fontawesome/phone-volume.svg": "73Em",
	"./fontawesome/phone.svg": "CH/4",
	"./fontawesome/photo-video.svg": "vX9m",
	"./fontawesome/pi.svg": "KVrF",
	"./fontawesome/piano-keyboard.svg": "gRvK",
	"./fontawesome/piano.svg": "+jWq",
	"./fontawesome/pie.svg": "26Mu",
	"./fontawesome/pig.svg": "d6/I",
	"./fontawesome/piggy-bank.svg": "VQjm",
	"./fontawesome/pills.svg": "fT63",
	"./fontawesome/pizza-slice.svg": "5Odb",
	"./fontawesome/pizza.svg": "racP",
	"./fontawesome/place-of-worship.svg": "Z6Xa",
	"./fontawesome/plane-alt.svg": "OyGo",
	"./fontawesome/plane-arrival.svg": "qqUd",
	"./fontawesome/plane-departure.svg": "CEMZ",
	"./fontawesome/plane-slash.svg": "hjm8",
	"./fontawesome/plane.svg": "/Mzm",
	"./fontawesome/planet-moon.svg": "3noi",
	"./fontawesome/planet-ringed.svg": "Z4cL",
	"./fontawesome/play-circle.svg": "OzU8",
	"./fontawesome/play.svg": "0bXl",
	"./fontawesome/plug.svg": "TX0i",
	"./fontawesome/plus-circle.svg": "YGPQ",
	"./fontawesome/plus-hexagon.svg": "HUs6",
	"./fontawesome/plus-octagon.svg": "I7So",
	"./fontawesome/plus-square.svg": "SltR",
	"./fontawesome/plus.svg": "6rlT",
	"./fontawesome/podcast.svg": "FgaC",
	"./fontawesome/podium-star.svg": "F/8v",
	"./fontawesome/podium.svg": "K3tT",
	"./fontawesome/police-box.svg": "bgxg",
	"./fontawesome/poll-h.svg": "2H+E",
	"./fontawesome/poll-people.svg": "prhH",
	"./fontawesome/poll.svg": "ZDas",
	"./fontawesome/poo-storm.svg": "IzbW",
	"./fontawesome/poo.svg": "Pq+0",
	"./fontawesome/poop.svg": "6cDP",
	"./fontawesome/popcorn.svg": "4Txg",
	"./fontawesome/portal-enter.svg": "hLqK",
	"./fontawesome/portal-exit.svg": "dubX",
	"./fontawesome/portrait.svg": "XxPy",
	"./fontawesome/pound-sign.svg": "qk8o",
	"./fontawesome/power-off.svg": "RzDa",
	"./fontawesome/pray.svg": "VtQJ",
	"./fontawesome/praying-hands.svg": "s50n",
	"./fontawesome/prescription-bottle-alt.svg": "baA3",
	"./fontawesome/prescription-bottle.svg": "/s7l",
	"./fontawesome/prescription.svg": "6Tjm",
	"./fontawesome/presentation.svg": "3/AB",
	"./fontawesome/print-search.svg": "mc6y",
	"./fontawesome/print-slash.svg": "Z1EQ",
	"./fontawesome/print.svg": "QnRQ",
	"./fontawesome/procedures.svg": "JN54",
	"./fontawesome/project-diagram.svg": "l7ct",
	"./fontawesome/projector.svg": "LW5B",
	"./fontawesome/pump-medical.svg": "2viH",
	"./fontawesome/pump-soap.svg": "Hu/o",
	"./fontawesome/pumpkin.svg": "ElJB",
	"./fontawesome/puzzle-piece.svg": "NVGi",
	"./fontawesome/qrcode.svg": "oMJr",
	"./fontawesome/question-circle.svg": "Nsk/",
	"./fontawesome/question-square.svg": "SO/n",
	"./fontawesome/question.svg": "8BoS",
	"./fontawesome/quidditch.svg": "1a7f",
	"./fontawesome/quote-left.svg": "AdW6",
	"./fontawesome/quote-right.svg": "2hBs",
	"./fontawesome/quran.svg": "eCU1",
	"./fontawesome/rabbit-fast.svg": "HSqE",
	"./fontawesome/rabbit.svg": "vK+k",
	"./fontawesome/racquet.svg": "uTzI",
	"./fontawesome/radar.svg": "1y8f",
	"./fontawesome/radiation-alt.svg": "b6V+",
	"./fontawesome/radiation.svg": "9SQZ",
	"./fontawesome/radio-alt.svg": "E7VG",
	"./fontawesome/radio.svg": "WT07",
	"./fontawesome/rainbow.svg": "dkCr",
	"./fontawesome/raindrops.svg": "pOlH",
	"./fontawesome/ram.svg": "FbwO",
	"./fontawesome/ramp-loading.svg": "5sjI",
	"./fontawesome/random.svg": "/u3p",
	"./fontawesome/raygun.svg": "S2eO",
	"./fontawesome/receipt.svg": "klM8",
	"./fontawesome/record-vinyl.svg": "qFmm",
	"./fontawesome/rectangle-landscape.svg": "V8BO",
	"./fontawesome/rectangle-portrait.svg": "3Ej0",
	"./fontawesome/rectangle-wide.svg": "uFMQ",
	"./fontawesome/recycle.svg": "DYPf",
	"./fontawesome/redo-alt.svg": "fTFY",
	"./fontawesome/redo.svg": "odaD",
	"./fontawesome/refrigerator.svg": "K15I",
	"./fontawesome/registered.svg": "fm2J",
	"./fontawesome/remove-format.svg": "niYC",
	"./fontawesome/repeat-1-alt.svg": "w5+A",
	"./fontawesome/repeat-1.svg": "7tV6",
	"./fontawesome/repeat-alt.svg": "ACjx",
	"./fontawesome/repeat.svg": "MD8o",
	"./fontawesome/reply-all.svg": "72J2",
	"./fontawesome/reply.svg": "//2g",
	"./fontawesome/republican.svg": "uPVJ",
	"./fontawesome/restroom.svg": "VdEt",
	"./fontawesome/retweet-alt.svg": "r3e/",
	"./fontawesome/retweet.svg": "rFCI",
	"./fontawesome/ribbon.svg": "aLEy",
	"./fontawesome/ring.svg": "5jap",
	"./fontawesome/rings-wedding.svg": "ZuOj",
	"./fontawesome/road.svg": "OI6H",
	"./fontawesome/robot.svg": "HpJb",
	"./fontawesome/rocket-launch.svg": "D/iA",
	"./fontawesome/rocket.svg": "QzI7",
	"./fontawesome/route-highway.svg": "BePz",
	"./fontawesome/route-interstate.svg": "zOUw",
	"./fontawesome/route.svg": "rTdM",
	"./fontawesome/router.svg": "iulG",
	"./fontawesome/rss-square.svg": "zoM4",
	"./fontawesome/rss.svg": "ujab",
	"./fontawesome/ruble-sign.svg": "+P0M",
	"./fontawesome/ruler-combined.svg": "Ictb",
	"./fontawesome/ruler-horizontal.svg": "Gifq",
	"./fontawesome/ruler-triangle.svg": "/X1H",
	"./fontawesome/ruler-vertical.svg": "6kGc",
	"./fontawesome/ruler.svg": "k9AP",
	"./fontawesome/running.svg": "ohic",
	"./fontawesome/rupee-sign.svg": "+K0P",
	"./fontawesome/rv.svg": "/j2D",
	"./fontawesome/sack-dollar.svg": "G9KX",
	"./fontawesome/sack.svg": "QYb6",
	"./fontawesome/sad-cry.svg": "B+wb",
	"./fontawesome/sad-tear.svg": "b2FQ",
	"./fontawesome/salad.svg": "CPoV",
	"./fontawesome/sandwich.svg": "kGFI",
	"./fontawesome/satellite-dish.svg": "3m62",
	"./fontawesome/satellite.svg": "qri7",
	"./fontawesome/sausage.svg": "tdhI",
	"./fontawesome/save.svg": "wjE7",
	"./fontawesome/sax-hot.svg": "LKjF",
	"./fontawesome/saxophone.svg": "5wGc",
	"./fontawesome/scalpel-path.svg": "GFFV",
	"./fontawesome/scalpel.svg": "Jd0W",
	"./fontawesome/scanner-image.svg": "mvNr",
	"./fontawesome/scanner-keyboard.svg": "FNgZ",
	"./fontawesome/scanner-touchscreen.svg": "Uosz",
	"./fontawesome/scanner.svg": "0FVw",
	"./fontawesome/scarecrow.svg": "xHwZ",
	"./fontawesome/scarf.svg": "hBsT",
	"./fontawesome/school.svg": "q8hI",
	"./fontawesome/screwdriver.svg": "GaE5",
	"./fontawesome/scroll-old.svg": "p0mj",
	"./fontawesome/scroll.svg": "VfD2",
	"./fontawesome/scrubber.svg": "eiiL",
	"./fontawesome/scythe.svg": "2KBb",
	"./fontawesome/sd-card.svg": "GkT/",
	"./fontawesome/search-dollar.svg": "tC4W",
	"./fontawesome/search-location.svg": "Bckg",
	"./fontawesome/search-minus.svg": "LWOB",
	"./fontawesome/search-plus.svg": "5njd",
	"./fontawesome/search.svg": "DqiJ",
	"./fontawesome/seedling.svg": "sZcU",
	"./fontawesome/send-back.svg": "MZpV",
	"./fontawesome/send-backward.svg": "yE/J",
	"./fontawesome/sensor-alert.svg": "Qbv2",
	"./fontawesome/sensor-fire.svg": "dpDI",
	"./fontawesome/sensor-on.svg": "BpBd",
	"./fontawesome/sensor-smoke.svg": "vuir",
	"./fontawesome/sensor.svg": "IYE6",
	"./fontawesome/server.svg": "7rfB",
	"./fontawesome/shapes.svg": "DGjV",
	"./fontawesome/share-all.svg": "ejaS",
	"./fontawesome/share-alt-square.svg": "Ud2j",
	"./fontawesome/share-alt.svg": "j1Y0",
	"./fontawesome/share-square.svg": "/Zcy",
	"./fontawesome/share.svg": "KZTK",
	"./fontawesome/sheep.svg": "yVY9",
	"./fontawesome/shekel-sign.svg": "24Gx",
	"./fontawesome/shield-alt.svg": "cpzs",
	"./fontawesome/shield-check.svg": "kYws",
	"./fontawesome/shield-cross.svg": "O7rJ",
	"./fontawesome/shield-virus.svg": "KhYv",
	"./fontawesome/shield.svg": "glSh",
	"./fontawesome/ship.svg": "b2Hg",
	"./fontawesome/shipping-fast.svg": "IEe1",
	"./fontawesome/shipping-timed.svg": "ruyg",
	"./fontawesome/shish-kebab.svg": "X+cL",
	"./fontawesome/shoe-prints.svg": "Px+v",
	"./fontawesome/shopping-bag.svg": "vWUh",
	"./fontawesome/shopping-basket.svg": "dZd6",
	"./fontawesome/shopping-cart.svg": "5WZC",
	"./fontawesome/shovel-snow.svg": "W0VF",
	"./fontawesome/shovel.svg": "Fq6Z",
	"./fontawesome/shower.svg": "Llel",
	"./fontawesome/shredder.svg": "kvjN",
	"./fontawesome/shuttle-van.svg": "MBD3",
	"./fontawesome/shuttlecock.svg": "YJ/b",
	"./fontawesome/sickle.svg": "0KO9",
	"./fontawesome/sigma.svg": "scXS",
	"./fontawesome/sign-in-alt.svg": "HWMX",
	"./fontawesome/sign-in.svg": "rWB4",
	"./fontawesome/sign-language.svg": "vMQk",
	"./fontawesome/sign-out-alt.svg": "fWvw",
	"./fontawesome/sign-out.svg": "cWCt",
	"./fontawesome/sign.svg": "2Teh",
	"./fontawesome/signal-1.svg": "yzU0",
	"./fontawesome/signal-2.svg": "IXd2",
	"./fontawesome/signal-3.svg": "A9Xk",
	"./fontawesome/signal-4.svg": "lXeF",
	"./fontawesome/signal-alt-1.svg": "zvry",
	"./fontawesome/signal-alt-2.svg": "KVtn",
	"./fontawesome/signal-alt-3.svg": "SDYo",
	"./fontawesome/signal-alt-slash.svg": "KfVG",
	"./fontawesome/signal-alt.svg": "7j9Z",
	"./fontawesome/signal-slash.svg": "2m0q",
	"./fontawesome/signal-stream.svg": "kdfF",
	"./fontawesome/signal.svg": "hXB1",
	"./fontawesome/signature.svg": "ujyy",
	"./fontawesome/sim-card.svg": "bHQF",
	"./fontawesome/sink.svg": "mm3Z",
	"./fontawesome/siren-on.svg": "tjSP",
	"./fontawesome/siren.svg": "rWKm",
	"./fontawesome/sitemap.svg": "5taD",
	"./fontawesome/skating.svg": "adaE",
	"./fontawesome/skeleton.svg": "glBU",
	"./fontawesome/ski-jump.svg": "KHCM",
	"./fontawesome/ski-lift.svg": "ampP",
	"./fontawesome/skiing-nordic.svg": "gW9k",
	"./fontawesome/skiing.svg": "cFyY",
	"./fontawesome/skull-cow.svg": "K1+0",
	"./fontawesome/skull-crossbones.svg": "/0sh",
	"./fontawesome/skull.svg": "f/MJ",
	"./fontawesome/slash.svg": "NpBD",
	"./fontawesome/sledding.svg": "PYGq",
	"./fontawesome/sleigh.svg": "Ldcf",
	"./fontawesome/sliders-h-square.svg": "5Cnc",
	"./fontawesome/sliders-h.svg": "RRDN",
	"./fontawesome/sliders-v-square.svg": "n5we",
	"./fontawesome/sliders-v.svg": "jO6e",
	"./fontawesome/smile-beam.svg": "Hvqi",
	"./fontawesome/smile-plus.svg": "Zs+H",
	"./fontawesome/smile-wink.svg": "I1xY",
	"./fontawesome/smile.svg": "ck8n",
	"./fontawesome/smog.svg": "ZMTf",
	"./fontawesome/smoke.svg": "IBAm",
	"./fontawesome/smoking-ban.svg": "z8WF",
	"./fontawesome/smoking.svg": "NeAo",
	"./fontawesome/sms.svg": "gDkK",
	"./fontawesome/snake.svg": "H2fh",
	"./fontawesome/snooze.svg": "YIGr",
	"./fontawesome/snow-blowing.svg": "ycQQ",
	"./fontawesome/snowboarding.svg": "3J8E",
	"./fontawesome/snowflake.svg": "DPAA",
	"./fontawesome/snowflakes.svg": "dviB",
	"./fontawesome/snowman.svg": "cyAW",
	"./fontawesome/snowmobile.svg": "TXOI",
	"./fontawesome/snowplow.svg": "cps8",
	"./fontawesome/soap.svg": "G4Cq",
	"./fontawesome/socks.svg": "3ik6",
	"./fontawesome/solar-panel.svg": "Aw46",
	"./fontawesome/solar-system.svg": "f9rS",
	"./fontawesome/sort-alpha-down-alt.svg": "3IaL",
	"./fontawesome/sort-alpha-down.svg": "M8nQ",
	"./fontawesome/sort-alpha-up-alt.svg": "ZYXX",
	"./fontawesome/sort-alpha-up.svg": "QowC",
	"./fontawesome/sort-alt.svg": "wP6F",
	"./fontawesome/sort-amount-down-alt.svg": "WALT",
	"./fontawesome/sort-amount-down.svg": "Ykjo",
	"./fontawesome/sort-amount-up-alt.svg": "JJ/R",
	"./fontawesome/sort-amount-up.svg": "aZ8T",
	"./fontawesome/sort-circle-down.svg": "VQWD",
	"./fontawesome/sort-circle-up.svg": "l5Z3",
	"./fontawesome/sort-circle.svg": "M6Lg",
	"./fontawesome/sort-down.svg": "FE+f",
	"./fontawesome/sort-numeric-down-alt.svg": "ASwR",
	"./fontawesome/sort-numeric-down.svg": "hKPc",
	"./fontawesome/sort-numeric-up-alt.svg": "wWIR",
	"./fontawesome/sort-numeric-up.svg": "r4Kl",
	"./fontawesome/sort-shapes-down-alt.svg": "gvee",
	"./fontawesome/sort-shapes-down.svg": "EqC1",
	"./fontawesome/sort-shapes-up-alt.svg": "i2mi",
	"./fontawesome/sort-shapes-up.svg": "wiqt",
	"./fontawesome/sort-size-down-alt.svg": "Osan",
	"./fontawesome/sort-size-down.svg": "Fj8U",
	"./fontawesome/sort-size-up-alt.svg": "/PK9",
	"./fontawesome/sort-size-up.svg": "QPps",
	"./fontawesome/sort-up.svg": "CjOP",
	"./fontawesome/sort.svg": "FlwW",
	"./fontawesome/soup.svg": "uBJo",
	"./fontawesome/spa.svg": "/dkC",
	"./fontawesome/space-shuttle.svg": "1uGt",
	"./fontawesome/space-station-moon-alt.svg": "2Krv",
	"./fontawesome/space-station-moon.svg": "izRw",
	"./fontawesome/spade.svg": "5ZY3",
	"./fontawesome/sparkles.svg": "hwkd",
	"./fontawesome/speaker.svg": "eYfh",
	"./fontawesome/speakers.svg": "TJLa",
	"./fontawesome/spell-check.svg": "Yo3B",
	"./fontawesome/spider-black-widow.svg": "V0aP",
	"./fontawesome/spider-web.svg": "4VVj",
	"./fontawesome/spider.svg": "k/Ek",
	"./fontawesome/spinner-third.svg": "cmFP",
	"./fontawesome/spinner.svg": "KN5t",
	"./fontawesome/splotch.svg": "5xm4",
	"./fontawesome/spray-can.svg": "CRdu",
	"./fontawesome/sprinkler.svg": "ud1G",
	"./fontawesome/square-full.svg": "odeE",
	"./fontawesome/square-root-alt.svg": "guF8",
	"./fontawesome/square-root.svg": "Nhkt",
	"./fontawesome/square.svg": "4Xz2",
	"./fontawesome/squirrel.svg": "lc1V",
	"./fontawesome/staff.svg": "A3nr",
	"./fontawesome/stamp.svg": "+3G/",
	"./fontawesome/star-and-crescent.svg": "2tZ9",
	"./fontawesome/star-christmas.svg": "ZBQF",
	"./fontawesome/star-exclamation.svg": "enZ+",
	"./fontawesome/star-half-alt.svg": "5CQ/",
	"./fontawesome/star-half.svg": "KFM3",
	"./fontawesome/star-of-david.svg": "JGx8",
	"./fontawesome/star-of-life.svg": "ERJB",
	"./fontawesome/star-shooting.svg": "xrUh",
	"./fontawesome/star.svg": "TKXq",
	"./fontawesome/starfighter-alt.svg": "V1Yy",
	"./fontawesome/starfighter.svg": "H8xy",
	"./fontawesome/stars.svg": "B2YD",
	"./fontawesome/starship-freighter.svg": "84id",
	"./fontawesome/starship.svg": "pbqR",
	"./fontawesome/steak.svg": "vj93",
	"./fontawesome/steering-wheel.svg": "v3rx",
	"./fontawesome/step-backward.svg": "GwbF",
	"./fontawesome/step-forward.svg": "ujPe",
	"./fontawesome/stethoscope.svg": "rsyl",
	"./fontawesome/sticky-note.svg": "CW2i",
	"./fontawesome/stocking.svg": "dggU",
	"./fontawesome/stomach.svg": "aj2K",
	"./fontawesome/stop-circle.svg": "zR34",
	"./fontawesome/stop.svg": "UcoJ",
	"./fontawesome/stopwatch-20.svg": "GkA0",
	"./fontawesome/stopwatch.svg": "h1HV",
	"./fontawesome/store-alt-slash.svg": "z9fj",
	"./fontawesome/store-alt.svg": "gtyb",
	"./fontawesome/store-slash.svg": "QmAG",
	"./fontawesome/store.svg": "uFiu",
	"./fontawesome/stream.svg": "mDvD",
	"./fontawesome/street-view.svg": "OlC3",
	"./fontawesome/stretcher.svg": "46wW",
	"./fontawesome/strikethrough.svg": "y9vA",
	"./fontawesome/stroopwafel.svg": "Ve+z",
	"./fontawesome/subscript.svg": "VLok",
	"./fontawesome/subway.svg": "axEl",
	"./fontawesome/suitcase-rolling.svg": "SdAQ",
	"./fontawesome/suitcase.svg": "4QgW",
	"./fontawesome/sun-cloud.svg": "td+K",
	"./fontawesome/sun-dust.svg": "JbLe",
	"./fontawesome/sun-haze.svg": "D58J",
	"./fontawesome/sun.svg": "bdrU",
	"./fontawesome/sunglasses.svg": "CCpk",
	"./fontawesome/sunrise.svg": "kgK3",
	"./fontawesome/sunset.svg": "hOpY",
	"./fontawesome/superscript.svg": "IUwM",
	"./fontawesome/surprise.svg": "dfzv",
	"./fontawesome/swatchbook.svg": "Se5X",
	"./fontawesome/swimmer.svg": "YMlC",
	"./fontawesome/swimming-pool.svg": "Z6nl",
	"./fontawesome/sword-laser-alt.svg": "1gg6",
	"./fontawesome/sword-laser.svg": "oAVK",
	"./fontawesome/sword.svg": "gnRr",
	"./fontawesome/swords-laser.svg": "dvbG",
	"./fontawesome/swords.svg": "nNxa",
	"./fontawesome/synagogue.svg": "3Lem",
	"./fontawesome/sync-alt.svg": "zE0q",
	"./fontawesome/sync.svg": "oyef",
	"./fontawesome/syringe.svg": "M55G",
	"./fontawesome/table-tennis.svg": "dGrt",
	"./fontawesome/table.svg": "X7ai",
	"./fontawesome/tablet-alt.svg": "7fwH",
	"./fontawesome/tablet-android-alt.svg": "R1p7",
	"./fontawesome/tablet-android.svg": "C5QH",
	"./fontawesome/tablet-rugged.svg": "UVK4",
	"./fontawesome/tablet.svg": "PxEe",
	"./fontawesome/tablets.svg": "bgsa",
	"./fontawesome/tachometer-alt-average.svg": "X1XG",
	"./fontawesome/tachometer-alt-fast.svg": "m9+B",
	"./fontawesome/tachometer-alt-fastest.svg": "YMOj",
	"./fontawesome/tachometer-alt-slow.svg": "i5My",
	"./fontawesome/tachometer-alt-slowest.svg": "2pxB",
	"./fontawesome/tachometer-alt.svg": "gPjm",
	"./fontawesome/tachometer-average.svg": "spfi",
	"./fontawesome/tachometer-fast.svg": "cHPv",
	"./fontawesome/tachometer-fastest.svg": "cmfA",
	"./fontawesome/tachometer-slow.svg": "c7MU",
	"./fontawesome/tachometer-slowest.svg": "cVqz",
	"./fontawesome/tachometer.svg": "zMRy",
	"./fontawesome/taco.svg": "5ZPC",
	"./fontawesome/tag.svg": "It1y",
	"./fontawesome/tags.svg": "J9G4",
	"./fontawesome/tally.svg": "FZ7u",
	"./fontawesome/tanakh.svg": "5j2r",
	"./fontawesome/tape.svg": "0Lhe",
	"./fontawesome/tasks-alt.svg": "7Eij",
	"./fontawesome/tasks.svg": "5zEy",
	"./fontawesome/taxi.svg": "6oQA",
	"./fontawesome/teeth-open.svg": "MLQk",
	"./fontawesome/teeth.svg": "oVZv",
	"./fontawesome/telescope.svg": "YCkF",
	"./fontawesome/temperature-down.svg": "elpp",
	"./fontawesome/temperature-frigid.svg": "R/n1",
	"./fontawesome/temperature-high.svg": "9A3z",
	"./fontawesome/temperature-hot.svg": "XP4q",
	"./fontawesome/temperature-low.svg": "5UkB",
	"./fontawesome/temperature-up.svg": "X/Ei",
	"./fontawesome/tenge.svg": "BRi0",
	"./fontawesome/tennis-ball.svg": "vHkD",
	"./fontawesome/terminal.svg": "Rb/7",
	"./fontawesome/text-height.svg": "vB/O",
	"./fontawesome/text-size.svg": "F4ZD",
	"./fontawesome/text-width.svg": "jlyy",
	"./fontawesome/text.svg": "RNqB",
	"./fontawesome/th-large.svg": "tsEZ",
	"./fontawesome/th-list.svg": "kKwW",
	"./fontawesome/th.svg": "LGiF",
	"./fontawesome/theater-masks.svg": "IviG",
	"./fontawesome/thermometer-empty.svg": "dOaU",
	"./fontawesome/thermometer-full.svg": "asHE",
	"./fontawesome/thermometer-half.svg": "iXUM",
	"./fontawesome/thermometer-quarter.svg": "9oaZ",
	"./fontawesome/thermometer-three-quarters.svg": "LsC8",
	"./fontawesome/thermometer.svg": "8o76",
	"./fontawesome/theta.svg": "YX0j",
	"./fontawesome/thumbs-down.svg": "kxgy",
	"./fontawesome/thumbs-up.svg": "UeK6",
	"./fontawesome/thumbtack.svg": "HDCp",
	"./fontawesome/thunderstorm-moon.svg": "8ude",
	"./fontawesome/thunderstorm-sun.svg": "EQXg",
	"./fontawesome/thunderstorm.svg": "UxCT",
	"./fontawesome/ticket-alt.svg": "3njB",
	"./fontawesome/ticket.svg": "Y2N8",
	"./fontawesome/tilde.svg": "5Qz1",
	"./fontawesome/times-circle.svg": "pmuF",
	"./fontawesome/times-hexagon.svg": "A7O2",
	"./fontawesome/times-octagon.svg": "4eKJ",
	"./fontawesome/times-square.svg": "KQGV",
	"./fontawesome/times.svg": "7rDK",
	"./fontawesome/tint-slash.svg": "7e23",
	"./fontawesome/tint.svg": "k9Qo",
	"./fontawesome/tire-flat.svg": "HZts",
	"./fontawesome/tire-pressure-warning.svg": "lFqx",
	"./fontawesome/tire-rugged.svg": "d5Wz",
	"./fontawesome/tire.svg": "v/b0",
	"./fontawesome/tired.svg": "Vp8g",
	"./fontawesome/toggle-off.svg": "XH6J",
	"./fontawesome/toggle-on.svg": "wCLL",
	"./fontawesome/toilet-paper-alt.svg": "aWak",
	"./fontawesome/toilet-paper-slash.svg": "Dpl6",
	"./fontawesome/toilet-paper.svg": "6Uiv",
	"./fontawesome/toilet.svg": "YY0o",
	"./fontawesome/tombstone-alt.svg": "VHEn",
	"./fontawesome/tombstone.svg": "lW9e",
	"./fontawesome/toolbox.svg": "cl09",
	"./fontawesome/tools.svg": "UNfi",
	"./fontawesome/tooth.svg": "ayen",
	"./fontawesome/toothbrush.svg": "km67",
	"./fontawesome/torah.svg": "yxXO",
	"./fontawesome/torii-gate.svg": "FFl6",
	"./fontawesome/tornado.svg": "kZJv",
	"./fontawesome/tractor.svg": "0n6N",
	"./fontawesome/trademark.svg": "70a0",
	"./fontawesome/traffic-cone.svg": "QTfK",
	"./fontawesome/traffic-light-go.svg": "usIM",
	"./fontawesome/traffic-light-slow.svg": "p6xN",
	"./fontawesome/traffic-light-stop.svg": "80Ln",
	"./fontawesome/traffic-light.svg": "COcQ",
	"./fontawesome/trailer.svg": "onGD",
	"./fontawesome/train.svg": "CghG",
	"./fontawesome/tram.svg": "aOKN",
	"./fontawesome/transgender-alt.svg": "11AI",
	"./fontawesome/transgender.svg": "1fBC",
	"./fontawesome/transporter-1.svg": "daeY",
	"./fontawesome/transporter-2.svg": "7Zz1",
	"./fontawesome/transporter-3.svg": "aLVx",
	"./fontawesome/transporter-empty.svg": "+8JX",
	"./fontawesome/transporter.svg": "SIc1",
	"./fontawesome/trash-alt.svg": "17Bk",
	"./fontawesome/trash-restore-alt.svg": "4aw6",
	"./fontawesome/trash-restore.svg": "Qk7t",
	"./fontawesome/trash-undo-alt.svg": "zcNy",
	"./fontawesome/trash-undo.svg": "dkVC",
	"./fontawesome/trash.svg": "a+Oo",
	"./fontawesome/treasure-chest.svg": "GtmU",
	"./fontawesome/tree-alt.svg": "Pmrb",
	"./fontawesome/tree-christmas.svg": "N3Xk",
	"./fontawesome/tree-decorated.svg": "YAy2",
	"./fontawesome/tree-large.svg": "CbMc",
	"./fontawesome/tree-palm.svg": "WQMv",
	"./fontawesome/tree.svg": "aLvu",
	"./fontawesome/trees.svg": "S+hB",
	"./fontawesome/triangle-music.svg": "fOnV",
	"./fontawesome/triangle.svg": "Yroh",
	"./fontawesome/trophy-alt.svg": "iQO2",
	"./fontawesome/trophy.svg": "dNTi",
	"./fontawesome/truck-container.svg": "6a7r",
	"./fontawesome/truck-couch.svg": "UMoT",
	"./fontawesome/truck-loading.svg": "N7b6",
	"./fontawesome/truck-monster.svg": "zyn6",
	"./fontawesome/truck-moving.svg": "sIOz",
	"./fontawesome/truck-pickup.svg": "FovS",
	"./fontawesome/truck-plow.svg": "Q5Uz",
	"./fontawesome/truck-ramp.svg": "mMAI",
	"./fontawesome/truck.svg": "c74U",
	"./fontawesome/trumpet.svg": "vO7m",
	"./fontawesome/tshirt.svg": "sRLa",
	"./fontawesome/tty.svg": "tqBb",
	"./fontawesome/turkey.svg": "wB0y",
	"./fontawesome/turntable.svg": "xlFg",
	"./fontawesome/turtle.svg": "aoDI",
	"./fontawesome/tv-alt.svg": "qAw+",
	"./fontawesome/tv-music.svg": "syQ3",
	"./fontawesome/tv-retro.svg": "yg3J",
	"./fontawesome/tv.svg": "3cFD",
	"./fontawesome/typewriter.svg": "8Rj4",
	"./fontawesome/ufo-beam.svg": "CXSa",
	"./fontawesome/ufo.svg": "H8Vq",
	"./fontawesome/umbrella-beach.svg": "HKBi",
	"./fontawesome/umbrella.svg": "Hztq",
	"./fontawesome/underline.svg": "xOry",
	"./fontawesome/undo-alt.svg": "T/fE",
	"./fontawesome/undo.svg": "3LTq",
	"./fontawesome/unicorn.svg": "I4Ct",
	"./fontawesome/union.svg": "dmQL",
	"./fontawesome/universal-access.svg": "SZ1d",
	"./fontawesome/university.svg": "UMpy",
	"./fontawesome/unlink.svg": "TeVf",
	"./fontawesome/unlock-alt.svg": "q19Y",
	"./fontawesome/unlock.svg": "DCRz",
	"./fontawesome/upload.svg": "iv0x",
	"./fontawesome/usb-drive.svg": "lctL",
	"./fontawesome/usd-circle.svg": "r9hO",
	"./fontawesome/usd-square.svg": "7d3h",
	"./fontawesome/user-alien.svg": "45oi",
	"./fontawesome/user-alt-slash.svg": "1BtE",
	"./fontawesome/user-alt.svg": "BMMS",
	"./fontawesome/user-astronaut.svg": "MKfK",
	"./fontawesome/user-chart.svg": "1HgM",
	"./fontawesome/user-check.svg": "aodX",
	"./fontawesome/user-circle.svg": "qBmw",
	"./fontawesome/user-clock.svg": "ykEo",
	"./fontawesome/user-cog.svg": "QCK/",
	"./fontawesome/user-cowboy.svg": "Dig6",
	"./fontawesome/user-crown.svg": "4um8",
	"./fontawesome/user-edit.svg": "Nnt5",
	"./fontawesome/user-friends.svg": "fBLq",
	"./fontawesome/user-graduate.svg": "GmGI",
	"./fontawesome/user-hard-hat.svg": "zPt/",
	"./fontawesome/user-headset.svg": "EawI",
	"./fontawesome/user-injured.svg": "mO6l",
	"./fontawesome/user-lock.svg": "HRk8",
	"./fontawesome/user-md-chat.svg": "dSN+",
	"./fontawesome/user-md.svg": "ZKu1",
	"./fontawesome/user-minus.svg": "ERkB",
	"./fontawesome/user-music.svg": "o1xZ",
	"./fontawesome/user-ninja.svg": "wStO",
	"./fontawesome/user-nurse.svg": "pWWO",
	"./fontawesome/user-plus.svg": "Kgkk",
	"./fontawesome/user-robot.svg": "2Lwq",
	"./fontawesome/user-secret.svg": "isnc",
	"./fontawesome/user-shield.svg": "5GC8",
	"./fontawesome/user-slash.svg": "kMT9",
	"./fontawesome/user-tag.svg": "zOWo",
	"./fontawesome/user-tie.svg": "YhYX",
	"./fontawesome/user-times.svg": "bXRZ",
	"./fontawesome/user-unlock.svg": "zCq8",
	"./fontawesome/user-visor.svg": "trEQ",
	"./fontawesome/user.svg": "lpUc",
	"./fontawesome/users-class.svg": "jSOZ",
	"./fontawesome/users-cog.svg": "dpGg",
	"./fontawesome/users-crown.svg": "AoXD",
	"./fontawesome/users-medical.svg": "HHXs",
	"./fontawesome/users-slash.svg": "G6uo",
	"./fontawesome/users.svg": "CYDw",
	"./fontawesome/utensil-fork.svg": "FMgn",
	"./fontawesome/utensil-knife.svg": "bmV0",
	"./fontawesome/utensil-spoon.svg": "hQAY",
	"./fontawesome/utensils-alt.svg": "pIsK",
	"./fontawesome/utensils.svg": "YyOD",
	"./fontawesome/vacuum-robot.svg": "rQX0",
	"./fontawesome/vacuum.svg": "Epbo",
	"./fontawesome/value-absolute.svg": "BAjx",
	"./fontawesome/vector-square.svg": "+g/n",
	"./fontawesome/venus-double.svg": "GecT",
	"./fontawesome/venus-mars.svg": "PpI+",
	"./fontawesome/venus.svg": "KwdP",
	"./fontawesome/vest-patches.svg": "9380",
	"./fontawesome/vest.svg": "TJjk",
	"./fontawesome/vhs.svg": "PbJa",
	"./fontawesome/vial.svg": "Vvge",
	"./fontawesome/vials.svg": "DB2t",
	"./fontawesome/video-plus.svg": "Cxpu",
	"./fontawesome/video-slash.svg": "fBAq",
	"./fontawesome/video.svg": "+EwC",
	"./fontawesome/vihara.svg": "jC8b",
	"./fontawesome/violin.svg": "JsBh",
	"./fontawesome/virus-slash.svg": "/3YE",
	"./fontawesome/virus.svg": "snRx",
	"./fontawesome/viruses.svg": "w6We",
	"./fontawesome/voicemail.svg": "z+qf",
	"./fontawesome/volcano.svg": "y9ce",
	"./fontawesome/volleyball-ball.svg": "0XLj",
	"./fontawesome/volume-down.svg": "elEV",
	"./fontawesome/volume-mute.svg": "z4oH",
	"./fontawesome/volume-off.svg": "Jm1M",
	"./fontawesome/volume-slash.svg": "8aRH",
	"./fontawesome/volume-up.svg": "clJv",
	"./fontawesome/volume.svg": "kWCO",
	"./fontawesome/vote-nay.svg": "gfSh",
	"./fontawesome/vote-yea.svg": "GZ02",
	"./fontawesome/vr-cardboard.svg": "vhpp",
	"./fontawesome/wagon-covered.svg": "1lt0",
	"./fontawesome/walker.svg": "1XC0",
	"./fontawesome/walkie-talkie.svg": "ze4h",
	"./fontawesome/walking.svg": "1VO0",
	"./fontawesome/wallet.svg": "sut8",
	"./fontawesome/wand-magic.svg": "ja8m",
	"./fontawesome/wand.svg": "SsRV",
	"./fontawesome/warehouse-alt.svg": "sQ9v",
	"./fontawesome/warehouse.svg": "augh",
	"./fontawesome/washer.svg": "ERqK",
	"./fontawesome/watch-calculator.svg": "0c/B",
	"./fontawesome/watch-fitness.svg": "ldMT",
	"./fontawesome/watch.svg": "dG8j",
	"./fontawesome/water-lower.svg": "m/0X",
	"./fontawesome/water-rise.svg": "7kTl",
	"./fontawesome/water.svg": "f1Wf",
	"./fontawesome/wave-sine.svg": "tbsU",
	"./fontawesome/wave-square.svg": "SZYy",
	"./fontawesome/wave-triangle.svg": "Npc/",
	"./fontawesome/waveform-path.svg": "Q0aO",
	"./fontawesome/waveform.svg": "vByW",
	"./fontawesome/webcam-slash.svg": "FwEk",
	"./fontawesome/webcam.svg": "H1Pu",
	"./fontawesome/weight-hanging.svg": "2M9R",
	"./fontawesome/weight.svg": "CU15",
	"./fontawesome/whale.svg": "GoHN",
	"./fontawesome/wheat.svg": "3f0I",
	"./fontawesome/wheelchair.svg": "9WBs",
	"./fontawesome/whistle.svg": "N/c4",
	"./fontawesome/wifi-1.svg": "OrNF",
	"./fontawesome/wifi-2.svg": "34kQ",
	"./fontawesome/wifi-slash.svg": "/nrd",
	"./fontawesome/wifi.svg": "oHdY",
	"./fontawesome/wind-turbine.svg": "WVkJ",
	"./fontawesome/wind-warning.svg": "vDnv",
	"./fontawesome/wind.svg": "eP96",
	"./fontawesome/window-alt.svg": "5m3O",
	"./fontawesome/window-close.svg": "7a7W",
	"./fontawesome/window-frame-open.svg": "5GSP",
	"./fontawesome/window-frame.svg": "EiMp",
	"./fontawesome/window-maximize.svg": "CIjK",
	"./fontawesome/window-minimize.svg": "pOqs",
	"./fontawesome/window-restore.svg": "J9D7",
	"./fontawesome/window.svg": "otjj",
	"./fontawesome/windsock.svg": "BHsu",
	"./fontawesome/wine-bottle.svg": "6Pv4",
	"./fontawesome/wine-glass-alt.svg": "tfQt",
	"./fontawesome/wine-glass.svg": "GNR7",
	"./fontawesome/won-sign.svg": "baL8",
	"./fontawesome/wreath.svg": "4ahE",
	"./fontawesome/wrench.svg": "ZEAs",
	"./fontawesome/x-ray.svg": "Q7sF",
	"./fontawesome/yen-sign.svg": "H3x6",
	"./fontawesome/yin-yang.svg": "YY+8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "TPdo";